import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { committeeActionCreators } from '../../../stores/lis-committee-store';
import { memberActionCreators } from '../../../stores/lis-members-store';
import { billActionCreators } from '../../../stores/lis-legislation-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import { patronActionCreators } from '../../../stores/lis-patron-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import AdvancedSearchBox from '../../../lis-shared/lis-search/lis-advanced-search-box';
import moment from 'moment-timezone';
import queryString from 'query-string';
import '../../../stylesheets/lis-public-view/public-view.css';
import BillCategories from '../../../lis-shared/lis-search/lis-search-categories';
import SearchSelections from '../../../lis-shared/lis-search/lis-search-selections';
import LegislationWatchlists from '../../../lis-shared/lis-search/lis-legislation-watchlists';
import CollectionControls from '../../../lis-shared/lis-search/lis-collection-controls'
import { cancelRequest } from '../../../services/request.service';
import { collectionActionCreators } from '../../../stores/lis-collection-store';
import { authActionCreators } from '../../../stores/lis-auth-store';
import ReportMaker from './lis-report-maker';
import BillInfoComponent from '../../../lis-shared/lis-search/lis-bill-info';
import SearchHelp from './lis-search-help';
import { reportActionCreators } from '../../../stores/lis-report-store';
import Select from 'react-select';
import { sortLegislations } from '../../../services/legislation-helper-service';
import { HistoricalRedirectPopup } from '../../../lis-shared/lis-layout/components/lis-popup-component';

const BILL_COLLECTION_AUTHOR = "LegislationCollections";
const PageSize = 50;

const validLegPrefixes = ["HB", "SB", "HJ", "SJ", "HR", "SR"];

class BillSearchComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCategories: !this.props.location.search,
            billList: [],
            billStatusCategoryList: [],
            billStatusCategoryListIsLoading: true,
            billEventOptions: [],
            selectedBillEvent: '',
            selectedBill: '',
            selectedKeywords: '',
            searchedKeywords: '',
            selectedBillAction: '',
            billEventStartDate: null,
            billEventEndDate: null,
            selectedBillSession: '',
            selectedBillType: '',
            previousSearch: '',
            searchType: { value: 'all', label: 'All' },
            selectedChamber: '',
            patronList: [],
            patronRoles: [],
            selectedBillNumbers: '',
            selectedBillRangeBeginning: '',
            selectedBillRangeEnd: '',
            selectedChapterNumber: '',
            filteredPatronList: [],
            selectedPatron: '',
            selectedPatronType: [],
            selectedBillStatusCategory: '',
            sessionOptions: [],
            billStatusStartDate: null,
            billStatusEndDate: null,
            committeeList: [],
            groupedCommitteeList: [],
            filteredCommitteeList: [],
            selectedCommittee: '',
            selectedSubcommittee: '',
            subcommitteeList: [],
            subjectList: [],
            selectedSubject: '',
            introDateList: [],
            collections: [],
            selectedCollection: '',
            selectedCollectionIndex: -1,
            billVersionList: [],
            selectedBillVersion: 'All',
            billSummaryList: [],
            selectedSummaryVersion: 'All',
            selectedLocation: 'Bill Text',
            criteriaTypes: [],
            checkedBills: [],
            lastCheckedBill: -1,
            showAllNotes: false,
            selectAllBills: false,
            collectionIsSaving: false,
            keywordUseGlobalSessionSearch: false,
            displayCrossSession: false,
            currentStatus: true,
            includeFailed: false,
            autoReport: false,
            showSidebar: this.props.history.location?.state !== 'close-sidebar',
            height: 1,
            showModal: false,
            introductionDate: null,
            showHelpModal: false,
            searchExecuted: false,
            displayChapterNumber: false,
            selectedSort: 'Bill|ASC',
            sortWatchlistsBy: 'ALPHABETICAL',
            messages: [],
            addedBills: [],
            holdOffLoading: false,
        };
        this.searchOnEnterPress = this.searchOnEnterPress.bind(this);
        this.toggleGroup = this.toggleGroup.bind(this);
        this.toggleShowCategories = this.toggleShowCategories.bind(this);
        this.clearForm = this.clearForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.getBillsResults = this.getBillsResults.bind(this);
        this.chamberChange = this.chamberChange.bind(this);
        this.sessionChange = this.sessionChange.bind(this);
        this.committeeChange = this.committeeChange.bind(this);
        this.handlePatronChange = this.handlePatronChange.bind(this);
        this.handlePatronTypeChange = this.handlePatronTypeChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSelectionClear = this.handleSelectionClear.bind(this);
        this.handleMultiSelectionClear = this.handleMultiSelectionClear.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.getCollections = this.getCollections.bind(this);
        this.selectCollection = this.selectCollection.bind(this);
        this.handleCollectionChange = this.handleCollectionChange.bind(this);
        this.createCollection = this.createCollection.bind(this);
        this.deleteCollection = this.deleteCollection.bind(this);
        this.addToWatchlists = this.addToWatchlists.bind(this);
        this.removeWatchlistBills = this.removeWatchlistBills.bind(this);
        this.toggleReportMaker = this.toggleReportMaker.bind(this);
        this.toggleAllBills = this.toggleAllBills.bind(this);
        this.handleBillCheckbox = this.handleBillCheckbox.bind(this);
        this.quickAddBills = this.quickAddBills.bind(this);
        this.toggleAllNotes = this.toggleAllNotes.bind(this);
        this.handleCurrentStatusChange = this.handleCurrentStatusChange.bind(this);
        this.handleIncludeFailedChange = this.handleIncludeFailedChange.bind(this);
        this.unload = this.unload.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.getSessions = this.getSessions.bind(this);
        this.toggleShowData = this.toggleShowData.bind(this);
        this.executeSearch = this.executeSearch.bind(this);
        this.toggleHelpModal = this.toggleHelpModal.bind(this);
        this.getReportTitle = this.getReportTitle.bind(this);
        this.handleToggleCompositeView = this.handleToggleCompositeView.bind(this);
        this.handleToggleSearchExecuted = this.handleToggleSearchExecuted.bind(this);
        this.updateSortWatchlists = this.updateSortWatchlists.bind(this);
        this.getTheLineCountAndFirstLineOfSomething = this.generateMessage.bind(this);
        this.closeMessage = this.closeMessage.bind(this);
        this.buildBillMessage = this.buildBillMessage.bind(this);
        this.scrollToElementWithRetry = this.scrollToElementWithRetry.bind(this);

        // The div that sorrounds the page is in this component but the function that needs to run to be able to make a search is in the child component.
        // This ref is used to call the child component's function.
        this.searchBox = React.createRef();
        this._billResultRefs = [];
    }

    componentDidMount() {
        // IF A SEARCH QUERY EXISTS
        let queryObj = '';
        const parsed = queryString.parse(this.props.location.search, { decode: false });
        let fullReload = false;
        if (window.__APP_LOADED_ONCE__) {

        } else {
            fullReload = true;
            window.__APP_LOADED_ONCE__ = true;
        }
        // If you refresh while having some of the collection results in the url, the results get off.
        // This clears that part of it out, only if its been reloaded. Doesn't quite work if they reload on a different page, but the idea is there.
        if (fullReload === true && parsed.collection && parseInt(parsed.collection ?? '-1') >= 0 && parsed.q) {
            this.getSessions(null, parsed.autoReport == 1);
            this.props.history.replace('/bill-search?collection=' + parsed.collection);
        } else if (parsed.q) {
            const base64 = parsed.q;
            const decodedSearch = window.atob(base64);
            queryObj = JSON.parse(decodedSearch);
            if (this.props.bills.storedBillList.length == 0) {
                delete queryObj.preserveScroll;
                delete queryObj.prevY;
                delete queryObj.hasNextPage;
                delete queryObj.skippedRecords;
                delete queryObj.totalResults;
                delete queryObj.height;
                delete queryObj.numSearchedIds;
            }

            this.setState(state => ({
                ...state,
                ...queryObj,
                searchMade: true
            }), () => {
                if (queryObj.preserveScroll) {
                    this.setState({
                        billList: this.props.bills.storedBillList,
                        fullLegislationList: this.props.bills.storedFullLegislationList,
                    }, () => {
                        this.scrollToElementWithRetry(10);
                    })
                }

                if (!parsed.autoReport) {
                    this.getSessions(queryObj);
                } else {
                    this.getSessions(null, parsed.autoReport == 1);
                }
            });
        } else {
            this.getSessions(null, parsed.autoReport == 1);
        }
        this.getBillStatusCategoryOptions();
        this.getBillVersionOptions();
        this.getBillSummaryOptions();
        this.getBillEventOptions();
        this.getPatronRoles();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.search !== prevProps.location.search) {
            const parsed = queryString.parse(this.props.location.search, { decode: false });
            // When going back to /bill search from a collection (or even a search, I guess), clear out the selected collection and explicitly show categories.
            if (window.location.href.replace(window.location.origin, '') === '/bill-search') {
                this.setState({
                    selectedCollection: '',
                    selectedCollectionIndex: -1,
                    showCategories: true
                })
            } else {
                let queryObj = '';
                if (parsed.q) {
                    const base64 = parsed.q;
                    const decodedSearch = window.atob(base64);
                    queryObj = JSON.parse(decodedSearch);
                    if (parsed.collection) {
                    } else {
                        // Back button from watchlist to search
                        this.setState({
                            selectedCollection: '',
                            selectedCollectionIndex: -1
                        })
                    }
                }
                if (!queryObj.preserveScroll && !parsed.collection) {
                    // Otherwise we get even more searches at the same time
                    this.executeSearch();
                }
            }
        }
        if (this.props.nav.session !== prevProps.nav.session) {
            if (!isNaN(parseInt(this.props.nav.session))) {
                this.sessionChange(this.props.nav.session);
            }
        }

        //get collections if user logs in/logged in user changes
        if (this.props.login.userProfile.email && this.props.login.userProfile.email !== prevProps.login.userProfile.email) {
            if (this.state.selectedSession.SessionID && this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR)) {
                this.getCollections("?SessionID=" + this.state.selectedSession.SessionID);
            } else if (this.state.collections && this.state.collections.length) {
                this.setState({ collections: [] })
            }
        }

        if (this.state.billList !== prevState.billList || this.state.showCategories !== prevState.showCategories) {
            if (window.innerWidth > 900) { //breaks mobile otherwise, and the sidebar toggle isn't shown on mobile anyways
                let height = document.getElementById('results-div');
                if (height && (height.scrollHeight / 540) !== this.state.height) {
                    this.setState({
                        height: (height.scrollHeight / 540) >= 1 ? (height.scrollHeight / 540) : 1
                    })
                } else {
                    this.setState({
                        height: 1
                    })
                }
            }
        }

        if (this.state.selectedCollectionIndex !== '' && this.state.selectedCollectionIndex > -1 && this.state.selectedCollectionIndex !== prevState.selectedCollectionIndex) {
            // In the sidebar panel, scroll the selected watchlist into view. Otherwise it just goes back to the top
            // Also, scroll to the watchlist header, rather than refoc on the list. Useful in mobile
            const selectedWatchlistInList = document.getElementsByClassName('watchlist-info');
            const watchlistHeader = document.getElementsByClassName('watchlist-info');
            if (selectedWatchlistInList && selectedWatchlistInList.length > 0 && !this.state.preserveScroll) {
                selectedWatchlistInList[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
            if (watchlistHeader && watchlistHeader.length > 0 && window.innerWidth <= 500) { // Doesn't quite get it to the top of the screen what with having to wait for it to load. Better than nothing.
                setTimeout(() => watchlistHeader[0].children[0].children[0].scrollIntoView(true));
            }
        }
    }

    executeSearch() {
        let queryObj = '';
        const parsed = queryString.parse(this.props.location.search, { decode: false });
        if (parsed.q) {
            const base64 = parsed.q;
            const decodedSearch = window.atob(base64);
            queryObj = JSON.parse(decodedSearch);
            //Remove any existing entries in the form and replace it with the content of the url
            this.clearForm();
            const displayChapterNumber = queryObj.selectedBillStatusCategory && this.state.billStatusCategoryList.find(it => it.Name.toLowerCase() === "acts of assembly chapters")?.LegislationCategoryID === queryObj.selectedBillStatusCategory;
            this.setState(state => ({
                ...state,
                ...queryObj,
                searchExecuted: true,
                displayChapterNumber,
                messages: [],
                addedBills: []
            }), () => {
                //If a member is already selected and there are no patron types selected then select chief patron by default
                if (this.state.selectedPatron && this.state.selectedPatronType.length === 0) {
                    const patronRoles = [1];
                    this.setState({
                        selectedPatronType: patronRoles
                    });
                }
                //If a committee is already selected and there is no legislation status then select 'In Committee' as the status
                if (this.state.selectedCommittee && !this.state.selectedBillStatusCategory) {
                    const selectedBillStatusCategory = this.state.billStatusCategoryList.find(status => status.Name === 'In Committee');
                    this.setState({
                        selectedBillStatusCategory: selectedBillStatusCategory ? selectedBillStatusCategory.LegislationCategoryID : ''
                    });
                }
                this.getSessions(queryObj);
            });
        } else if (!parsed.collection) {
            //this means the user hit the back button from a query and there are no longer any params in the url,
            //and the user should be back at the base search page with categories
            this.clearForm(true);
        }
    }

    getSessions(queryObj, autoReport) {
        let sessions = ''
        if (!this.state.sessionOptions.length) {
            sessions = this.props.actions.getSessionList()
                .then(() => {
                    this.setState({
                        sessionOptions: this.props.session.sessionList
                    })
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                });
        } else {
            sessions = () => Promise.resolve();
        }

        Promise.all([sessions]).then(() => {
            let selectedSession = '';
            let defaultSession = '';
            this.state.sessionOptions.forEach(session => {
                if (queryObj && session.SessionID === queryObj.selectedSession) {
                    selectedSession = session;
                    this.props.actions.changeSession(session.SessionCode);
                } else if (session.SessionCode === this.props.nav.session && !selectedSession) {
                    selectedSession = session;
                }
                if (session.IsDefault) {
                    defaultSession = session;
                }
            });
            //Only set the session to default if the queryObj doesn't have a sessionID and the the session selector doesn't have a sessionID
            if (!selectedSession) {
                selectedSession = defaultSession;
            }

            if (selectedSession) {
                const sessionStartObj = selectedSession.SessionEvents && selectedSession.SessionEvents.length && selectedSession.SessionEvents.find(date => date.DisplayName === "Session Start");
                const startDate = sessionStartObj ? moment(sessionStartObj.ActualDate).tz('America/New_York').format("MM/DD/YYYY") : '';
                const dateParam = 'effectiveDate=' + encodeURIComponent(startDate);
                const sessionParam = 'sessionID=' + selectedSession.SessionID;
                this.getPatrons(sessionParam);
                this.getSubjects(sessionParam);
                this.getCommittees(sessionParam);
                this.getIntroDates(sessionParam)

                this.setState({ selectedSession }, () => {
                    if (this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR)) {
                        this.getCollections("?SessionID=" + this.state.selectedSession.SessionID);
                        if (autoReport) {
                            window.addEventListener("beforeunload", this.unload);
                            this.toggleReportMaker();
                            this.setState({
                                autoReport: true
                            })
                        }
                    }
                    if (queryObj && queryObj.preserveScroll) {
                        const options = {
                            root: null,
                            rootMargin: "0px",
                            threshold: 1.0
                        };

                        this.observer = new IntersectionObserver(
                            this.handleObserver.bind(this),
                            options
                        );
                        this.observer.observe(this.loadingRef);

                    } else if (queryObj && !queryObj.sessionOnly) {
                        this.setState({ billList: [], fullLegislationList: [], skippedRecords: 0 }, () => {
                            this.handleSearch()
                        })
                    } else {
                        this.setState({ showCategories: true })
                    }

                    document.querySelector('body').addEventListener('keydown', this.searchOnEnterPress);
                })
            } else {
                this.setState({ failedToGetSessions: true })
            }
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
            console.log(err)
        });
    }

    componentWillUnmount() {
        document.querySelector('body').removeEventListener('keydown', this.searchOnEnterPress);
        cancelRequest();
        //Handle leaving the page when we arrived here from the Create Report button in the calendar
        if (this.state.autoReport && this.state.selectedCollection != '' && this.state.showReportMaker) {
            window.removeEventListener("beforeunload", this.unload);
        }
    }

    searchOnEnterPress(event) {
        if (event.key === 'Enter' && !this.state.isFetching) {
            //Pressing enter while on a react-select will select an option. A search should not happen because of that.
            if (!event.target.id.includes('react-select') && !event.target.className.includes('note-area') && !event.target.className.includes('quick-search') && event.target.id !== "userId" && event.target.id !== "userPassword" && event.target.id !== "report-personal-message") {
                if (!this.state.selectedChamber && !this.state.selectedBillEvent && !this.state.selectedBillType && !this.state.selectedCommittee && !this.state.selectedSubcommittee && !this.state.selectedPatron && !this.state.selectedSubject && !this.state.selectedKeywords && !this.state.selectedBillNumbers && !this.state.selectedBillRangeBeginning && !this.state.selectedBillRangeEnd && !this.state.selectedSubject && !this.state.selectedChapterNumber && !this.state.selectedBillStatusCategory) {
                    //there are not any search parameters provided, don't execute a search
                    return;
                }
                this.searchBox.current.handleSubmit();
            }
        }
    }

    toggleShowCategories(val) {
        this.setState({
            showCategories: val
        }, () => {
            if (this.state.showCategories) {
                this.props.history.push("/bill-search");
            }
        });
    }

    toggleGroup(groupName) {
        this.setState(state => ({
            [groupName]: !state[groupName]
        }));
    }

    toggleShowData(billID, bool) {
        if (bool === undefined) {
            this.setState(prevState => ({
                [billID]: !prevState[billID]
            }));
        } else {
            //not just toggling, we're explicitly setting (e.g. if searching by keyword, and a bill has been expanded, if the keyword search location changes to bill text,
            //don't just toggle all (which would reset that bill to false), set them all to true)
            this.setState({
                [billID]: bool
            })
        }
    }

    clearForm(clearUrl, clearBillData, searchWhenDone) {
        this.setState({
            selectedBillEvent: '',
            selectedBill: '',
            selectedKeywords: '',
            searchedKeywords: '',
            selectedBillAction: '',
            billEventStartDate: null,
            billEventEndDate: null,
            selectedBillSession: '',
            selectedBillType: '',
            selectedBillNumbers: '',
            selectedBillRangeBeginning: '',
            selectedBillRangeEnd: '',
            selectedChapterNumber: '',
            subcommitteeList: [],
            selectedPatron: '',
            selectedPatronType: '',
            selectedChamber: '',
            selectedBillStatusCategory: '',
            billStatusStartDate: null,
            billStatusEndDate: null,
            selectedCommittee: '',
            selectedSubcommittee: '',
            selectedSubject: '',
            isPending: null,
            mostFrequent: null,
            allLegislation: null,
            includeFailed: false,
            selectedBillVersion: 'All',
            selectedSummaryVersion: 'All',
            selectedLocation: 'Bill Text',
            displaySelectedLocation: "Bill Text",
            introductionDate: null
        }, () => {
            if (clearUrl) {
                this.props.history.push('/bill-search');
                this.setState({ billList: [], fullLegislationList: [], skippedRecords: 0, showCategories: true })
            }
            if (clearBillData) {
                this.setState({
                    billList: []
                })
            }
            if (searchWhenDone) {
                this.handleSearch();
            }
        });

    }

    handleSubmit(queryObj) {
        const newObj = Object.assign({}, queryObj, { SortBy: this.state.selectedSort });
        let encodedSearch = window.btoa(JSON.stringify(newObj));
        //if it is the same search (i.e. same parameters) as the current one, updating the url won't work since it will be the same, just execute it manually
        const parsed = queryString.parse(this.props.location.search, { decode: false });
        // Unselect the current watchlist
        this.setState({
            selectedCollection: '',
            selectedCollectionIndex: -1
        });
        if (parsed.q && parsed.q === encodedSearch) {
            this.executeSearch();
        } else {
            this.props.history.push('/bill-search?q=' + encodedSearch);
        }
    }

    handleSearch(skipIdsCall, observed) {
        if (this.state.failedToGetSessions) { return; }
        //Format the selected options to be sent to the API
        //Add bill range to list of bills
        let selectedBillNumbers = this.state.selectedBillNumbers?.trim() ?? "";
        if (this.state.selectedBillRangeBeginning && this.state.selectedBillRangeEnd) {
            selectedBillNumbers = selectedBillNumbers ? selectedBillNumbers + ',' : selectedBillNumbers;
            selectedBillNumbers += this.state.selectedBillRangeBeginning + '-' + this.state.selectedBillRangeEnd;
        }
        let keywordVersion = null;
        switch (this.state.selectedLocation) {
            case ('Bill Text'):
                if (this.state.selectedBillVersion !== 'All') {
                    keywordVersion = { KeywordLegislationVersionID: this.state.selectedBillVersion }
                }
                break;
            case ('Summary'):
                if (this.state.selectedSummaryVersion !== 'All') {
                    keywordVersion = { KeywordSummaryVersionID: this.state.selectedSummaryVersion }
                }
                break;
        }

        // Build the param array with param names as the keys
        const params = {
            ChamberCode: this.state.selectedChamber ? this.state.selectedChamber.value : null,
            chamberObject: this.state.selectedChamber ? this.state.selectedChamber : "",
            CommitteeID: this.state.selectedSubcommittee || this.state.selectedCommittee || null,
            subcommittee: this.state.selectedSubcommittee ? true : false,
            parentCommittee: this.state.selectedSubcommittee ? this.state.selectedCommittee : null,
            PatronTypes: this.state.selectedPatronType || null,
            LegislationNumbers: selectedBillNumbers ? [{ LegislationNumber: selectedBillNumbers.replaceAll(" ", "") }] : null,
            ChapterNumber: this.state.selectedChapterNumber,
            SessionID: this.state.keywordUseGlobalSessionSearch ? null : this.state.selectedSession.SessionID,
            StartDate: this.state.billStatusStartDate ? moment(this.state.billStatusStartDate).tz('America/New_York').format('MM/DD/YYYY') : null,
            EndDate: this.state.billStatusEndDate ? moment(this.state.billStatusEndDate).tz('America/New_York').format() : null,
            KeywordExpression: this.state.selectedKeywords || null,
            KeywordLocation: this.state.selectedLocation || null,
            ...keywordVersion,
            MemberID: this.state.selectedPatron,
            SubjectIndexID: this.state.selectedSubject,
            LegislationCategoryID: this.state.selectedBillStatusCategory,
            LegislationEventTypeID: this.state.selectedBillEvent,
            EventStartDate: this.state.billEventStartDate ? moment(this.state.billEventStartDate).tz('America/New_York').format("MM/DD/YYYY") : null,
            EventEndDate: this.state.billEventEndDate ? moment(this.state.billEventEndDate).tz('America/New_York').format("MM/DD/YYYY") : null,
            IsPending: this.state.isPending || null,
            MostFrequent: this.state.mostFrequent || null,
            AllLegislation: this.state.allLegislation || this.state.AllLegislation || null,
            KeywordUseGlobalSessionSearch: this.state.keywordUseGlobalSessionSearch,
            CurrentStatus: this.state.currentStatus,
            IncludeFailed: this.state.includeFailed,
            IntroductionDate: this.state.introductionDate,
            SortBy: this.state.selectedSort,
        }
        //Open the fieldset if one of the form inputs is filled out
        if (params.LegislationNumbers) {
            this.setState({
                billFieldset: true
            });
        }
        if (params.KeywordExpression) {
            this.setState({
                keywordFieldset: true
            });
        }
        if (params.LegislationCategoryID || params.ChamberCode) {
            this.setState({
                statusFieldset: true
            });
        }
        if (params.EventStartDate || params.EventEndDate) {
            this.setState({
                activityFieldset: true
            });
        }
        if (params.MemberID) {
            this.setState({
                membersFieldset: true
            });
        }
        if (params.CommitteeID) {
            this.setState({
                committeesFieldset: true
            });
        }
        if (params.SubjectIndexID) {
            this.setState({
                subjectFieldset: true
            });
        }
        if (params.AllLegislation) {
            this.setState({
                allLegislation: true
            })
        }

        this.setState({
            searchMade: true,
            displaySelectedLocation: this.state.selectedLocation
        });

        //use existing search params if the user has scrolled to the next page (i.e. ignore any possible changes to the params on the side)
        this.getBillsResults(skipIdsCall && this.state.params ? this.state.params : params, skipIdsCall, observed);
    }

    getBillsResults(params, skipIdsCall, observed, callback) {

        //if the user searches hb1-hb4 and expands all of these bills to see further info, and then search hb1-hb5, leave open their previously expanded bills for them;
        //however, if the existing search (if there is one, i.e. this new one is not the first search they're making) is a bill text keyword search, which automatically expands all of them in order to show bill text matches,
        //then close these in the new search results as there's a good chance they don't care for the expanded info regarding patrons/summary/etc
        const closeBillInfo = this.state.params?.KeywordLocation === "Bill Text" && this.state.params?.KeywordExpression && (params?.KeywordLocation !== "Bill Text" || !params?.KeywordExpression);

        this.setState({
            isFetching: true,
            showCategories: false,
            searchedKeywords: params.KeywordExpression //without this, if the user edits the keyword in the adv search box but does not submit, the existing bill version hit count links will nonetheless use the new value and not work
        })

        if (!this.state.skippedRecords) {
            window.scrollTo(0, 0);
        }

        let getResultsPromise;
        let hasResults = true;
        let numSearchedIds;
        if (params.MostFrequent) {
            getResultsPromise = this.props.actions.getMostFrequentBillList("?sessionID=" + params.SessionID + "&includeFailed=" + params.IncludeFailed);
        } else {
            //break this up into three calls: 1) get the legislation numbers (i.e. 'skinny list') of all results, 2) get the full list of objects with pagination, 3) get the hit counts if it's a billtext keyword search
            //we need the skinny list to know all the legislation numbers for creating reports, but don't want to get all the data for each yet (i.e. paginate)
            if (skipIdsCall) {
                const paginatedLegislationIds = [...this.state.fullLegislationList].slice(this.state.skippedRecords, this.state.skippedRecords + PageSize);
                getResultsPromise = this.props.actions.getBillListByIds({ "LegislationIds": paginatedLegislationIds }, null, true);
                numSearchedIds = this.state.numSearchedIds + paginatedLegislationIds.length;
            } else {
                getResultsPromise = this.props.actions.getLegislationIdsList(params).then(() => {
                    let legislationIdsResponse = { ... this.props.bills.legislationIdsList };
                    //Filter to only one result per bill per session since DB sometimes returns duplicates which messes up pagination
                    legislationIdsResponse.LegislationIds = legislationIdsResponse.LegislationIds.filter((item, pos) => legislationIdsResponse.LegislationIds.findIndex(i => i.LegislationNumber === item.LegislationNumber && i.SessionID === item.SessionID) === pos);
                    this.setState({ fullLegislationList: legislationIdsResponse.LegislationIds })
                    const paginatedLegislationIds = [...legislationIdsResponse.LegislationIds].slice(0, PageSize);
                    numSearchedIds = paginatedLegislationIds.length;
                    if (paginatedLegislationIds.length) {
                        return this.props.actions.getBillListByIds({ "LegislationIds": paginatedLegislationIds }, null, true);
                    } else {
                        hasResults = false;
                        return Promise.resolve();
                    }
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    this.setState({
                        isFetching: false
                    });
                })
            }
        }

        getResultsPromise.then(() => {
            let billList;
            if (!params.MostFrequent && this.state.skippedRecords) {
                // Swtiching to a watchlist after doing a search and going to the next page - clear the existing bill list, otherwise it appends the watchlist to the pagination results
                if (this.state.selectedCollectionIndex !== '' && this.state.selectedCollectionIndex > -1) {
                    // Scrolling down on a watchlist with > 50 bills would clear it
                    if (skipIdsCall) {
                        billList = [...this.state.billList, ...this.props.bills.billListByIds];
                    } else {
                        billList = [...this.props.bills.billListByIds];
                    }
                } else {
                    billList = [...this.state.billList.concat(hasResults ? this.props.bills.billListByIds : [])];
                }
            } else if (!params.MostFrequent) {
                billList = hasResults ? [...this.props.bills.billListByIds] : [];
            } else {
                billList = [...this.props.bills.mostFrequentBillList];
            }
            //Filter to only one result per bill per session since DB sometimes returns duplicates which messes up pagination
            billList = billList.filter((item, pos) => billList.findIndex(i => i.LegislationNumber === item.LegislationNumber && i.SessionID === item.SessionID) === pos);
            this.setState({
                params: params,
                billList: billList,
                numSearchedIds,
                totalResults: billList && billList.length ? params.MostFrequent ? billList.length : this.state.fullLegislationList.length : 0, //if we got IDs back but no full legislation object results, display '0 Results' since none are actually being shown. Example of this is when you search a bill number with cross session turned on
                hasNextPage: numSearchedIds && this.state.fullLegislationList.length > numSearchedIds ? true : false,
                isFetching: false,
                checkedBills: !params.MostFrequent && this.state.skippedRecords ? this.state.checkedBills : [],
                lastCheckedBill: !params.MostFrequent && this.state.skippedRecords ? this.state.lastCheckedBill : -1,
                selectAllBills: false,
                displayCrossSession: this.state.keywordUseGlobalSessionSearch
            }, () => {
                if (callback) {
                    callback();
                }
                if (observed) {
                    let queryObj = { ...params };
                    queryObj.preserveScroll = true;
                    queryObj.prevY = this.state.prevY;
                    queryObj.hasNextPage = this.state.hasNextPage;
                    queryObj.skippedRecords = this.state.skippedRecords;
                    queryObj.totalResults = this.state.totalResults;
                    queryObj.height = this.state.height;
                    queryObj.numSearchedIds = this.state.numSearchedIds;
                    queryObj.includeFailed = this.state.includeFailed;
                    queryObj.allLegislation = this.state.allLegislation;
                    queryObj.selectedWatchlistID = this.state.selectedCollection.WatchListID; // The whole obj is too big for the url

                    if (this.state.selectedBillRangeBeginning !== "") {
                        queryObj.selectedBillRangeBeginning = this.state.selectedBillRangeBeginning;
                    }
                    if (this.state.selectedBillRangeEnd !== "") {
                        queryObj.selectedBillRangeEnd = this.state.selectedBillRangeEnd;
                    }
                    if (this.state.selectedKeywords !== "") {
                        queryObj.selectedKeywords = this.state.selectedKeywords;
                        queryObj.selectedLocation = this.state.selectedLocation;
                        queryObj.keywordUseGlobalSessionSearch = this.state.keywordUseGlobalSessionSearch;
                        if (this.state.selectedLocation === "Bill Text") {
                            queryObj.selectedBillVersion = this.state.selectedBillVersion
                        }
                    }
                    if (this.state.billStatusStartDate) {
                        queryObj.billStatusStartDate = this.state.billStatusStartDate;
                    }
                    if (this.state.billStatusEndDate) {
                        queryObj.billStatusEndDate = this.state.billStatusEndDate;
                    }
                    if (this.state.selectedBillStatusCategory !== "") {
                        queryObj.selectedBillStatusCategory = this.state.selectedBillStatusCategory;
                        queryObj.currentStatus = this.state.currentStatus
                    }
                    if (this.state.selectedChamber !== "") {
                        queryObj.selectedChamber = this.state.selectedChamber;
                    }
                    if (this.state.selectedCommittee !== "") {
                        queryObj.selectedCommittee = this.state.selectedCommittee;
                    }
                    if (this.state.selectedSubcommittee !== "") {
                        queryObj.selectedSubcommittee = this.state.selectedSubcommittee;
                    }
                    if (this.state.selectedPatron !== "") {
                        queryObj.selectedPatron = this.state.selectedPatron;
                        queryObj.selectedPatronType = this.state.selectedPatronType;
                    }
                    if (this.state.selectedSubject !== "") {
                        queryObj.selectedSubject = this.state.selectedSubject;
                    }

                    if (this.state.selectedSort !== "") {
                        queryObj.selectedSort = this.state.selectedSort;
                    }
                    let encodedSearch = window.btoa(JSON.stringify(queryObj));
                    if (this.state.selectedCollection.WatchListID) {
                        this.props.history.push(`/bill-search?collection=${this.state.selectedCollection.WatchListID}&q=${encodedSearch}`);
                    } else {
                        this.props.history.push('/bill-search?q=' + encodedSearch);
                    }
                }
                this.props.actions.storeBillList({ billList: this.state.billList, fullLegislationList: this.state.fullLegislationList });
                if (closeBillInfo)
                    [...this.state.billList].forEach(b => this.toggleShowData(b.LegislationID, false))
                const options = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 1.0
                };

                this.observer = new IntersectionObserver(
                    this.handleObserver.bind(this),
                    options
                );
                this.observer.observe(this.loadingRef);

                //if bill text search, get hit counts
                if (params.KeywordLocation === 'Bill Text' && params.KeywordExpression && hasResults) {
                    const LOADING = 'LOADING';
                    const legislationTextIDs = [...this.props.bills.billListByIds].map(bill => bill.SearchText && bill.SearchText.map(text => { text.countMatches = LOADING; return { "LegislationTextID": text.LegislationTextID } })).flat();
                    let hitCountRequestBody = {
                        "Documents": legislationTextIDs,
                        "Location": "Bill Text",
                        "KeywordExpression": params.KeywordExpression
                    };

                    this.props.actions.getLegislationTextsHitCounts(hitCountRequestBody).then(() => {
                        const hitCounts = [...this.props.bills.legislationTextsHitCounts];
                        billList = [...this.state.billList];
                        hitCounts.forEach(hitCount => {
                            const associatedBillSearchTextIndexes = billList.reduce((r, b, i) => r.concat(b.SearchText && b.SearchText.find(st => st.LegislationTextID === hitCount.LegislationTextID) ? i : []), []);
                            associatedBillSearchTextIndexes.forEach(index => {
                                billList[index].SearchText.find(st => st.LegislationTextID === hitCount.LegislationTextID).countMatches = hitCount.HitCount;
                            })
                        })
                        billList.filter(bill => bill.SearchText && bill.SearchText.find(st => st.countMatches === LOADING)).forEach(bill => {
                            bill.SearchText.filter(st => st.countMatches === LOADING).forEach(st => { st.countMatches = null })
                        })

                        this.setState({ billList })
                    }).catch(err => {
                        if (err === 'Aborted') {
                            return;
                        }
                        this.setState({
                            isFetching: false
                        });
                    })
                }
            })
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
            this.setState({
                isFetching: false
            });
        })
    }

    handleObserver(entities, observer) {
        const y = entities[0].boundingClientRect.y;
        if (!this.state.showCategories && this.state.billList.length && this.state.hasNextPage && !this.state.isFetching && this.state.prevY > y && !this.state.holdOffLoading) {
            this.setState({ skippedRecords: this.state.numSearchedIds }, () => {
                if (!this.state.selectedCollection || this.state.searchMade) {
                    this.handleSearch(true, true);
                } else {
                    const bills = [...this.state.selectedCollection.WatchListLegislation].filter(l => !l.DeletionDate).map(l => l.LegislationID);
                    if (bills.length > 0) {
                        let legislationIds = [];
                        for (let i = 0; i < bills.length; i++) {
                            legislationIds.push({ LegislationId: bills[i] });
                        }

                        const params = {
                            LegislationIDs: legislationIds,
                            SessionID: this.state.selectedSession.SessionID
                        }

                        this.setState({ searchMade: false }, () => {
                            this.getBillsResults(params, true, true);
                        })
                    }
                }
            });
        }
        this.setState({ prevY: y });
    }

    getBillStatusCategoryOptions() {
        // Get Bill Status references for bill status typeahead
        this.props.actions.getBillStatusCategoryReferences().then(() => {
            let billStatusReferences = [...this.props.bills.billStatusCategoryReferences];
            billStatusReferences.forEach(ref => {
                ref.label = ref.Name
                ref.value = ref.LegislationCategoryID
            });
            if (this.state.selectedCommittee && !this.state.selectedBillStatusCategory) {
                const selectedBillStatusCategory = billStatusReferences.find(status => status.Name === 'In Committee');
                this.setState({
                    selectedBillStatusCategory: selectedBillStatusCategory ? selectedBillStatusCategory.LegislationCategoryID : ''
                });
            }
            const displayChapterNumber = this.state.selectedBillStatusCategory && billStatusReferences.find(it => it.Name.toLowerCase() === "acts of assembly chapters")?.LegislationCategoryID === this.state.selectedBillStatusCategory;
            this.setState({
                billStatusCategoryList: billStatusReferences,
                billStatusCategoryListIsLoading: false,
                displayChapterNumber
            });
        });
    }

    getBillVersionOptions() {
        this.props.actions.getBillVersionRef().then(() => {
            let topOfList = [{ Name: 'All Versions', LegislationVersionID: 'All' }];
            let billVersionReferences = topOfList.concat(this.props.bills.billVersionRef);
            billVersionReferences.forEach(ref => {
                ref.label = ref.Name
                ref.value = ref.LegislationVersionID
            });
            this.setState({
                billVersionList: billVersionReferences,
            });
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
        });
    }

    getBillSummaryOptions() {
        this.props.actions.getBillSummaryRef().then(() => {
            let topOfList = [{ Name: 'All Summary Versions', SummaryVersionID: 'All' }];
            let billSummaryReferences = topOfList.concat(this.props.bills.billSummaryRef);
            billSummaryReferences.forEach(ref => {
                ref.label = ref.Name
                ref.value = ref.SummaryVersionID
            });
            this.setState({
                billSummaryList: billSummaryReferences,
            });
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
        });
    }

    getBillEventOptions() {
        this.props.actions.getBillEventReferences("?isSearchable=true&isActive=true").then(() => {
            let billEventReferences = [...this.props.bills.billEventRef];
            billEventReferences.forEach(ref => {
                ref.label = ref.LegislationDescription
                ref.value = `${ref.EventCode}-${ref.IsPassed}`
            });
            this.setState({
                billEventOptions: billEventReferences
            });
        });
    }

    getPatrons(sessionParam) {
        // Get Patrons list for typeahead
        this.props.actions.getMemberList(sessionParam).then(() => {
            let memberList = [...this.props.members.memberList];
            memberList.forEach(patron => {
                patron.label = patron.ListDisplayName + ' ' + '(' + patron.ChamberCode + ')';
                patron.value = patron.MemberID;
            });
            const member = memberList.find(member => member.MemberID === this.state.selectedPatron);
            if (member && this.state.selectedPatronType.length === 0) {
                this.setState({
                    selectedPatronType: [1]
                });
            }
            this.setState({
                patronList: memberList,
                filteredPatronList: memberList,
            });
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
            console.log(err)
        });
    }

    getSubjects(sessionParam) {
        this.props.actions.getSubjectList('?' + sessionParam)
            .then(() => {
                this.setState({
                    subjectList: this.props.bills.subjectList
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err)
            });
    }

    getPatronRoles() {
        this.props.actions.getPatronRoles()
            .then(() => {
                const patronRoles = [...this.props.patrons.patronRoles];
                patronRoles.forEach(role => {
                    role.label = role.Name;
                    role.value = role.PatronTypeID;
                });
                this.setState({
                    patronRoles: patronRoles,
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err)
            });
    }

    getCommittees(sessionParam) {
        this.props.actions.getCommitteeList(sessionParam).then(() => {
            let committeeList = [...this.props.committee.committeeList];
            committeeList.forEach(committee => {
                committee.label = committee.Name;
                committee.value = committee.CommitteeID;
            });
            let groupedCommitteeList = [{ "label": "House Committees", "ChamberCode": "H", "options": committeeList.filter(c => c.ChamberCode === "H") }, { "label": "Senate Committees", "ChamberCode": "S", "options": committeeList.filter(c => c.ChamberCode === "S") }]
            this.setState({
                committeeList: committeeList.map(c => ({ ...c, label: c.label + ' ' + '(' + c.ChamberCode + ')' })),
                groupedCommitteeList: groupedCommitteeList,
                filteredCommitteeList: groupedCommitteeList
            });
            //If a committee is already selected then that committee's subcommittees need to be retrieved
            if (this.state.selectedCommittee) {
                this.getSubcommittees(this.state.selectedCommittee);
            }
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
            console.log(err)
        });
    }

    getSubcommittees(id) {
        this.props.actions.getCommitteeList("parentCommitteeID=" + id)
            .then(() => {
                let committeeList = [...this.props.committee.committeeList];
                committeeList.forEach(committee => {
                    committee.label = '(' + committee.ChamberCode + ') ' + committee.Name;
                    committee.value = committee.CommitteeID;
                });
                this.setState({
                    subcommitteeList: committeeList
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err)
            });
    }

    getIntroDates(sessionParam) {
        this.props.actions.getIntroDateList('?' + sessionParam)
            .then(() => {
                let datesList = [];
                this.props.bills.introDateList.forEach(date => datesList.push(moment(date.IntroductionDate).tz('America/New_York')));
                this.setState({
                    introDateList: datesList
                })
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err)
            });
    }

    sessionChange(code) {
        const selectedSession = this.state.sessionOptions.find(session => session.SessionCode === code);
        if (!selectedSession) {
            return;
        }
        const sessionParam = 'sessionID=' + selectedSession.SessionID;
        this.getPatrons(sessionParam);
        this.getSubjects(sessionParam);
        this.getCommittees(sessionParam);
        this.getIntroDates(sessionParam);
        this.getCollections("?SessionID=" + selectedSession.SessionID);

        const parsed = queryString.parse(this.props.location.search, { decode: false });
        if (parsed.q) {
            const base64 = parsed.q;
            const decodedSearch = window.atob(base64);
            let queryObj = JSON.parse(decodedSearch);
            if (queryObj.selectedSession) {
                queryObj.selectedSession = selectedSession.SessionID;
                this.handleSubmit(queryObj);
                return;
            }
        } else {
            this.setState({ currentStatus: selectedSession.IsActive })
        }

        if (this.state.selectedBillStatusCategory) {
            this.setState({
                selectedPatron: '',
                selectedPatronType: '',
                selectedCommittee: '',
                selectedSubcommittee: '',
                selectedSubject: '',
                selectedSession: selectedSession,
                billList: [],
                fullLegislationList: [],
                skippedRecords: 0
            }, () => {
                this.handleSearch();
            });
        } else {
            this.setState({
                selectedPatron: '',
                selectedPatronType: '',
                selectedCommittee: '',
                selectedSubcommittee: '',
                selectedSubject: '',
                selectedSession: selectedSession,
                billList: [],
                fullLegislationList: [],
                skippedRecords: 0
            }, () => {
                const parsed = queryString.parse(this.props.location.search, { decode: false });
                if (parsed.q) {
                    this.handleSearch();
                }
            });
        }
    }

    chamberChange(value, forceSearchWhenClearing) {
        this.setState({
            selectedChamber: value
        }, () => {
            forceSearchWhenClearing === true && this.searchBox.current.handleSubmit()
        });
        if (value) {
            const patronList = [...this.state.patronList];
            const committeeList = [...this.state.groupedCommitteeList];
            //Remove the patrons from the patronList that do not fit the current selected chamber
            //Remove the committees from the committee list that do not fit the current selected chamber
            let filteredPatronList = patronList.filter(patron => patron.ChamberCode === value.value);
            let filteredCommitteeList = committeeList.filter(committee => committee.ChamberCode === value.value);
            this.setState({
                filteredPatronList: filteredPatronList,
                filteredCommitteeList: filteredCommitteeList,
            });
        } else {
            // 'all' has been selected so show all patrons/committees
            this.setState({
                filteredPatronList: this.state.patronList,
                filteredCommitteeList: this.state.groupedCommitteeList,
            });
        }
        // Reset all the values that are chamber specific
        this.setState({
            selectedPatron: '',
            selectedPatronType: '',
            selectedCommittee: '',
            selectedSubcommittee: ''
        });
    }

    committeeChange(opt, forceSearchWhenClearing) {
        this.setState({
            selectedCommittee: opt ? opt.value : null,
            selectedSubcommittee: null
        }, () => {
            forceSearchWhenClearing === true && this.searchBox.current.handleSubmit()
        });
        if (opt) {
            if (!this.state.selectedBillStatusCategory) {
                const selectedBillStatusCategory = this.state.billStatusCategoryList.find(status => status.Name === 'In Committee');
                this.setState({
                    selectedBillStatusCategory: selectedBillStatusCategory ? selectedBillStatusCategory.LegislationCategoryID : ''
                });
            }
            this.getSubcommittees(opt.CommitteeID)
        };
    }

    handlePatronChange(opt, forceSearchWhenClearing) {
        this.setState({
            selectedPatron: opt ? opt.value : null,
            selectedPatronType: opt ? [1] : []
        }, () => {
            forceSearchWhenClearing === true && this.searchBox.current.handleSubmit()
        });
    }

    handlePatronTypeChange(options) {
        let values = [];
        if (options) {
            options.forEach(opt => values.push(opt.value));
        }
        this.setState({
            selectedPatronType: values,
            selectedPatron: values.length > 0 ? this.state.selectedPatron : null
        });
    }

    handleSelectChange = (opt, name, forceSearchWhenClearing) => {
        this.setState({
            [name]: opt ? opt.value : null
        });
        if (name === 'selectedBillStatusCategory') {
            if (opt) {
                if ([2, 3, 4, 6, 7, 11, 22, 16, 17, 21, 27].includes(opt.LegislationCategoryID)) {
                    this.setState({
                        currentStatus: true,
                        billStatusStartDate: null,
                        billStatusEndDate: null,
                        includeFailed: false
                    }, () => {
                        forceSearchWhenClearing === true && this.searchBox.current.handleSubmit()
                    });
                } else if ([1, 5, 23, 24, 18, 26, 29, 8, 9, 10, 19, 14, 20, 25, 13, 15, 28].includes(opt.LegislationCategoryID)) {
                    this.setState({
                        currentStatus: false,
                        includeFailed: true
                    });
                }
            } else {
                this.setState({
                    selectedCommittee: null,
                    selectedSubcommittee: null
                }, () => {
                    forceSearchWhenClearing === true && this.searchBox.current.handleSubmit()
                });
            }
        }
    }

    handleDateChange = (val, name) => {
        this.setState({
            [name]: val
        });
    }

    handleTextChange = (evt, name) => {
        let value = evt.target.value;
        if (['selectedChapterNumber', 'selectedBillRangeBeginning', 'selectedBillRangeEnd'].includes(name)) {
            value = value.replace(/[^a-zA-Z0-9]/, "");
        }
        this.setState({ [name]: value });
    }

    handleSelectionClear(key) {
        //Clearing some form inputs changes the value of other form inputs. Handle them here.

        switch (key) {
            case "selectedBillStatusCategory":
                this.handleSelectChange(null, "selectedBillStatusCategory", true);
                break;
            case "selectedPatron":
                this.handlePatronChange(null, true);
                break;
            case "selectedCommittee":
                this.committeeChange(null, true);
                break;
            case "selectedChamber":
                this.chamberChange(null, true);
                break;
            default:
                this.setState({
                    [key]: ''
                }, () => {
                    this.searchBox.current.handleSubmit();
                });
        }
    }

    handleMultiSelectionClear(key, index, forceSearchWhenClearing) {
        let value = [...this.state[key]];
        value.splice(index, 1);
        this.setState({
            [key]: value,
            selectedPatron: key !== 'selectedPatronType' ? this.state.selectedPatron : value.length > 0 ? this.state.selectedPatron : null,
            showUpdateSearchButton: true
        }, () => {
            //Have to add the updated value to the query string, otherwise the search pulls from state and is one click behind user action
            const parsed = queryString.parse(this.props.location.search, { decode: false });
            const decodedSearch = window.atob(parsed.q);
            let queryObj = JSON.parse(decodedSearch);
            queryObj[key] = value;
            const encodedSearch = window.btoa(JSON.stringify(queryObj));
            this.props.history.push('/bill-search?q=' + encodedSearch + (this.state.selectedCollection ? '&collection=' + this.state.selectedCollection.WatchListID : ''));

            forceSearchWhenClearing && this.searchBox.current.handleSubmit()
        })
    }

    handleRadioChange() {
        if (window.env && window.env.HISTORICAL_DATA_REDIRECT && !this.state.keywordUseGlobalSessionSearch && !this.props.login.userClaims.roles.find(role => role === "CrossSearch")) {
            this.setState({
                historicalSessionRedirect: (redirect) => {
                    if (redirect) {
                        let a = document.createElement('a');
                        a.target = '_blank';
                        a.href = `https://legacylis.virginia.gov`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                    this.setState({ historicalSessionRedirect: false })
                }
            })
            return;
        }
        this.setState({
            keywordUseGlobalSessionSearch: !this.state.keywordUseGlobalSessionSearch
        }, () => {
            if (this.state.keywordUseGlobalSessionSearch) {
                this.setState({
                    includeFailed: false
                })
            }
        })
    }

    handleCurrentStatusChange() {
        this.setState({
            currentStatus: !this.state.currentStatus
        }, () => {
            if (this.state.currentStatus) {
                this.setState({
                    billStatusStartDate: null,
                    billStatusEndDate: null
                })
            }
        })
    }

    handleIncludeFailedChange() {
        this.setState({
            includeFailed: !this.state.includeFailed,
        })
    }

    getCollections(params) {
        this.setState({
            collectionIsLoading: true
        });
        this.props.actions.getCollections(params)
            .then(() => {
                const parsed = queryString.parse(this.props.location.search);
                const sortedCollections = this.props.collection.collections.toSorted((a, b) =>
                    this.state.sortWatchlistsBy === 'MODIFICATION_DATE' ? (new Date(b?.ModificationDate) - new Date(a?.ModificationDate)) :
                        a?.Name.toLowerCase() > b?.Name.toLowerCase() ? 1 : -1)
                const collectionIndex = sortedCollections.findIndex(coll => coll.WatchListID === parseInt(parsed.collection));
                this.setState({
                    collections: sortedCollections,
                    collectionIsLoading: false,
                }, () => {
                    if (collectionIndex !== -1) {
                        this.selectCollection(collectionIndex)
                    }
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return
                }
                this.setState({
                    collectionIsLoading: false
                });
            });
        this.props.actions.getCriteriaTypes()
            .then(() => {
                this.setState({
                    criteriaTypes: this.props.collection.criteriaTypes
                })
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err)
            });
    }

    selectCollection(collectionIndex, returningFromSearch) {
        if (collectionIndex === -1) {
            this.setState({
                selectedCollectionIndex: -1,
                quickAddErr: '',
                selectedCollection: '',
                billList: [],
                fullLegislationList: [],
                skippedRecords: 0,
                searchMade: true,
                messages: [],
                addedBills: []
            })
            this.props.history.push('/bill-search');
            this.clearForm();
        } else {
            // Remove object references so the state does not mutate
            const selectedCollection = JSON.parse(JSON.stringify(this.state.collections[collectionIndex] || ''))
            if (selectedCollection.IsPaid && !Boolean(this.props.login.userClaims.claims.find(claim => claim.Scope === "Paid" && claim.Resource === "LegislationCollections" && claim.RoleName === "PaidLegislationCollectionsAuthor")) && !Boolean(this.props.login.userClaims.resources.find(resource => resource === "PaidLegislationCollectionsAuthor" || resource === "All"))) {
                alert("The watchlist you are trying to access is a paid watchlist. As a free user, you are no longer able to access this watchlist.");
                return;
            }
            const parsed = queryString.parse(this.props.location.search, { decode: false });
            let keepQueryContent = false;
            if (parsed.q) {
                const base64 = parsed.q;
                const decodedSearch = window.atob(base64);
                const queryObj = JSON.parse(decodedSearch);
                keepQueryContent = queryObj.selectedWatchlistID && queryObj.selectedWatchlistID === selectedCollection.WatchListID;
            }

            // Go to the watchlist page if changing watchlists or picking one from a search
            if (!keepQueryContent) {
                this.props.history.push(`/bill-search?collection=${selectedCollection.WatchListID}`);
            }

            this.setState({
                selectedCollectionIndex: collectionIndex,
                selectedCollection: selectedCollection,
                showCategories: false,
                billList: !returningFromSearch && parsed.q ? this.state.billList : [],
                fullLegislationList: !returningFromSearch && parsed.q ? this.state.fullLegislationList : [],
                skippedRecords: !returningFromSearch && parsed.q ? this.state.skippedRecords : 0,
                searchMade: false,
                showAllNotes: !returningFromSearch && parsed.q ? this.state.showAllNotes : false,
                messages: [],
                addedBills: [],
                prevY: 0
            });
            if (!keepQueryContent) { // Otherwise we request the bills again
                const bills = selectedCollection.WatchListLegislation.filter(l => !l.DeletionDate).sort(sortLegislations).map(l => l.LegislationID);
                if (bills.length > 0) {
                    let legislationIds = [];
                    for (let i = 0; i < bills.length; i++) {
                        legislationIds.push({ LegislationId: bills[i] });
                    }

                    const params = {
                        LegislationIDs: legislationIds,
                        SessionID: this.state.selectedSession.SessionID
                    }
                    this.getBillsResults(params);
                } else {
                    // Reset to 0 items when switching to an empty watchlist
                    this.setState({
                        totalResults: 0,
                        billList: [],
                        fullLegislationList: [],
                        skippedRecords: 0,
                        searchMade: false
                    });
                }
            }
            this.setState({
                checkedBills: []
            })
            this.clearForm();
        }
    }

    handleCollectionChange(collection, callback) {
        if (this.state.collectionIsSaving) {
            return
        }
        this.setState({
            collectionIsSaving: true
        });
        this.props.actions.saveCollections({ WatchLists: [collection] })
            .then(() => {
                let collectionSave = [...this.props.collection.collectionSave][0];
                // The api does not return WatchListLegislation or NotificationCriterias at all if it is empty. To stop it from being undefined it is set to a blank array.
                collectionSave.WatchListLegislation = collectionSave.WatchListLegislation || [];
                // We get back ALL LEGISLATION FROM ALL SESSIONS from the save (not the initial get) so stop it.
                collectionSave.WatchListLegislation = collectionSave.WatchListLegislation.filter(s => s.Sessions.find(ss => ss.SessionID === this.state.selectedSession.SessionID));;
                collectionSave.NotificationCriterias = collectionSave.NotificationCriterias || [];
                // Collections need to be resorted as the name could be changed and the mod date definitely has
                let collections = [...this.state.collections];
                const unsortedCollectionIndex = collections.findIndex(coll => coll.WatchListID === collectionSave.WatchListID);
                collections[unsortedCollectionIndex] = collectionSave;
                const sortedCollections = collections.toSorted((a, b) =>
                    this.state.sortWatchlistsBy === 'MODIFICATION_DATE' ? (new Date(b?.ModificationDate) - new Date(a?.ModificationDate)) :
                        a?.Name.toLowerCase() > b?.Name.toLowerCase() ? 1 : -1)
                const sortedCollectionIndex = sortedCollections.findIndex(coll => coll.WatchListID === collectionSave.WatchListID);
                this.setState({
                    collectionIsSaving: false,
                    collections: sortedCollections,
                    selectedCollectionIndex: sortedCollectionIndex,
                    selectedCollection: collectionSave
                }, () => {
                    if (callback) {
                        callback();
                    }
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                if (callback) {
                    callback(err);
                }
                this.setState({
                    collectionIsSaving: false
                });
                let message;
                if (err && JSON.parse(err)) {
                    const errorMsg = JSON.parse(err).Name;
                    message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                } else {
                    message = "Save Failed";
                }
                this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
            });
    }

    createCollection(collection) {
        this.setState({
            collectionIsSaving: true
        });
        this.props.actions.saveCollections({ WatchLists: [collection] }, true)
            .then(() => {
                let collections = [...this.state.collections];
                let selectedCollection = [...this.props.collection.collectionSave][0]
                // The api does not return WatchListLegislation or NotificationCriterias at all if it is empty. To stop it from being undefined it is set to a blank array.
                selectedCollection.WatchListLegislation = selectedCollection.WatchListLegislation || [];
                selectedCollection.NotificationCriterias = selectedCollection.NotificationCriterias || [];
                collections.unshift(selectedCollection);
                collections.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()))
                this.setState({
                    collections: collections,
                    collectionIsSaving: false,
                    showCategories: false
                }, () => {
                    this.selectCollection(collections.findIndex(c => c.WatchListID === selectedCollection.WatchListID));
                });
            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                this.setState({
                    collectionIsSaving: false
                });
                let message;
                if (err && JSON.parse(err)) {
                    const errorMsg = JSON.parse(err).Name;
                    message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                } else {
                    message = "Save Failed";
                }
                this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
            });
    }

    deleteCollection() {
        this.setState({
            collectionIsSaving: true
        });
        let collection = { ...this.state.selectedCollection };
        let selectedCollectionIndex = this.state.selectedCollectionIndex;
        collection.DeletionDate = new Date();
        this.props.actions.saveCollections({ WatchLists: [collection] })
            .then(() => {
                let collections = [...this.state.collections];
                const idx = collections.findIndex(coll => coll.WatchListID === collection.WatchListID);
                if (idx > -1)
                    collections.splice(idx, 1);
                else
                    collections.splice(selectedCollectionIndex, 1);
                this.setState({
                    selectedCollection: '',
                    selectedCollectionIndex: -1,
                    collections: collections,
                    collectionIsSaving: false,
                    searchMade: true,
                    billList: [],
                    fullLegislationList: [],
                    skippedRecords: 0
                }, () => {
                    this.props.history.replace(`/bill-search`);
                });

            }).catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                this.setState({
                    collectionIsSaving: false,
                });
                this.props.actions.makeToast([{ message: "Delete Failed", type: "failure" }]);
            });
    }

    addToWatchlists(watchlists, merge, callback, label) {
        let billsToAdd = [];
        let messages = [];
        if (merge) {
            let selectedCollection = { ...this.state.selectedCollection };
            if (selectedCollection) {
                selectedCollection.WatchListLegislation.filter(l => !l.DeletionDate).forEach(leg => { billsToAdd.push(leg) })
            } else {
                return;
            }
        } else {
            this.state.checkedBills.forEach((c, i) => {
                if (c) {
                    billsToAdd.push(this.state.billList[i]);
                }
            });
        }
        let duplicatedBills = [];
        watchlists.forEach(watchlist => {
            billsToAdd.forEach(bill => {
                if (watchlist.__isNew__) {
                    watchlist.Name = watchlist.label;
                    watchlist.Description = `Created on ${moment().tz('America/New_York').format('MM/DD/YYYY')}`;
                    watchlist.WatchListLegislation = [];
                    delete watchlist.label;
                    delete watchlist.__isNew__;
                    delete watchlist.value;
                }
                // Make sure the bill isn't already a part of the watchlist
                if (!watchlist.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID) || watchlist.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID).DeletionDate) {
                    watchlist.WatchListLegislation.push({
                        LegislationID: bill.LegislationID,
                        LegislationNumber: bill.LegislationNumber,
                        Sessions: [{ SessionID: bill.SessionID }],
                        WatchListID: watchlist.WatchListID,
                        Note: merge ? bill.Note : null
                    });
                } else if (merge && !!bill.Note) { // Combine notes
                    const leg = watchlist.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID);
                    leg.Note = (leg.Note ? leg.Note + '\n' : '') + bill.Note;
                } else {
                    duplicatedBills.push({ "Watchlist": watchlist.Name, "LegislationNumber": bill.LegislationNumber });
                }
            });
        })
        this.setState({
            collectionIsSaving: true
        }, () => {
            let collections = [...this.state.collections];
            this.props.actions.saveCollections({ WatchLists: watchlists })
                .then(() => {
                    let watchlistSave = [...this.props.collection.collectionSave];
                    let savedCollectionIndex;
                    let savedCollectionId
                    watchlistSave.forEach(res => {
                        if (!collections.find(coll => coll.WatchListID === res.WatchListID)) {
                            collections.unshift(res);
                            savedCollectionId = collections[0].WatchListID;
                        } else {
                            savedCollectionIndex = collections.findIndex(coll => coll.WatchListID === res.WatchListID);
                            collections[savedCollectionIndex] = res;
                            // The save call returns all legislation across all sessions for the watchlist, so we need to filter it down to the current session.
                            if (collections[savedCollectionIndex].WatchListLegislation) {
                                const filteredLegislation = collections[savedCollectionIndex].WatchListLegislation.filter(leg => leg.Sessions.find(s => s.SessionID === this.state.selectedSession?.SessionID));
                                collections[savedCollectionIndex].WatchListLegislation = filteredLegislation;
                            }
                            savedCollectionId = collections[savedCollectionIndex].WatchListID;
                        }
                        res.WatchListLegislation = res.WatchListLegislation || [];
                        res.NotificationCriterias = res.NotificationCriterias || [];
                    })
                    // Stay on current collection if merging.
                    // Navigate to new watchlist if copying. We need to get that one's id, and then index to propely select it. Requires sorting collections.
                    if (savedCollectionId) {
                        if (this.state.sortWatchlistsBy === 'MODIFICATION_DATE') {
                            collections.sort((a, b) => new Date(b.ModificationDate) - new Date(a.ModificationDate));
                        } else {
                            collections.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));
                        }
                        if (label === 'merge') {
                            savedCollectionIndex = collections.findIndex(c => c.WatchListID === this.state.selectedCollection.WatchListID);
                        } else {
                            savedCollectionIndex = collections.findIndex(c => c.WatchListID === watchlistSave[watchlistSave.length - 1].WatchListID);
                        }
                    }
                    if (label === 'merge') {
                        this.setState({
                            collectionIsSaving: false,
                            collections: collections,
                            selectedCollectionIndex: savedCollectionIndex,
                        });
                    } else if (label === 'copy') {
                        this.setState({
                            collectionIsSaving: false,
                            collections: collections,
                            selectedCollection: collections[savedCollectionIndex],
                            selectedCollectionIndex: savedCollectionIndex,
                        }, () => {
                            this.selectCollection(this.state.selectedCollectionIndex);
                        });
                        this.props.history.replace(`/bill-search?collection=${collections[savedCollectionIndex].WatchListID}`)
                    } else {
                        this.setState({
                            collectionIsSaving: false,
                            collections: collections,
                            selectedCollection: '',
                            selectedCollectionIndex: -1,
                            checkedBills: [],
                        });
                    }
                    if (!merge) {
                        if (duplicatedBills.length > 0) {
                            const duplicateMessages = [watchlists.length].fill('');
                            const counts = [watchlists.length].fill(0);
                            watchlists.forEach((watchlist, index) => {
                                const billsInThisWatchlist = duplicatedBills.filter(bill => bill.Watchlist === watchlist.Name).map(bill => bill.LegislationNumber);
                                counts[index] = billsInThisWatchlist.length;
                                if (counts[index] > 0) {
                                    const messageText = this.buildBillMessage(billsInThisWatchlist, 'warning', watchlist.Name);
                                    duplicateMessages[index] = messageText;
                                }
                            });
                            messages = duplicateMessages.map(msg => this.generateMessage(msg, 'warning'));
                            const oopsAllDupes = counts.filter(c => c === billsToAdd.length).length === counts.length;
                            if (oopsAllDupes) {
                                billsToAdd = [];
                            }
                        }
                        let addedBills = [...this.state.addedBills];
                        if (billsToAdd.length > 0) {
                            const successMessages = [watchlists.length].fill('');
                            watchlists.forEach((watchlist, index) => {
                                const billsNotAlreadyInThisWatchlist = billsToAdd.filter(bill =>
                                    !duplicatedBills.find(dupBill => dupBill.Watchlist === watchlist.Name && dupBill.LegislationNumber === bill.LegislationNumber))
                                    .map(bill => bill.LegislationNumber);
                                addedBills = addedBills.concat(billsNotAlreadyInThisWatchlist);
                                if (billsNotAlreadyInThisWatchlist.length > 0) {
                                    const billsMessage = this.buildBillMessage(billsNotAlreadyInThisWatchlist, 'success', watchlist.Name);
                                    successMessages[index] = billsMessage;
                                }
                            })
                            messages = messages.concat(
                                successMessages.filter(msg => msg !== '')
                                    .map(msg => this.generateMessage(msg, 'success')));
                            addedBills = Array.from(new Set(addedBills));
                        }
                        this.setState({
                            messages,
                            addedBills
                        });
                    } else if (label === 'merge') {
                        this.props.actions.makeToast([{ message: "Watchlist has successfully been imported", type: "success" }]);
                    } else {
                        this.props.actions.makeToast([{ message: "Watchlist has successfully been copied", type: "success" }]);
                    }
                    if (callback) {
                        callback(collections)
                    }
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.setState({
                        collectionIsSaving: false
                    });
                    let message;
                    if (err && JSON.parse(err)) {
                        const errorMsg = JSON.parse(err).Name;
                        message = errorMsg && errorMsg.includes('Public users are') ? errorMsg : 'Save Failed'
                    } else {
                        message = "Save Failed";
                    }
                    this.props.actions.makeToast([{ message: message, type: "failure", long: message.includes('Public users are') }]);
                })
        });
    }

    removeWatchlistBills() {
        let selectedCollection = { ...this.state.selectedCollection };
        let billList = [...this.state.billList];
        let fullLegislationList = [...this.state.fullLegislationList];
        let removedBillCount = 0;
        const originalLength = billList.length;
        const removedBills = [];
        this.setState({ messages: [] });
        this.state.checkedBills.forEach((_cb, cbIndex) => {
            if (_cb) { //sometimes the value will be undefined, don't use those
                const legislationIndex = selectedCollection.WatchListLegislation.findIndex(leg => !leg.DeletionDate && leg.LegislationID === this.state.billList[cbIndex].LegislationID);
                if (legislationIndex !== -1) {
                    selectedCollection.WatchListLegislation[legislationIndex].DeletionDate = new Date().toISOString();
                    removedBills.push(billList[cbIndex - removedBillCount].LegislationNumber);
                    billList.splice(cbIndex - removedBillCount, 1);
                    fullLegislationList.splice(cbIndex - removedBillCount, 1);
                    removedBillCount++; //need to know how many we've removed since the index for billList won't be accurate anymore the next time through
                }
            }
        });
        const messageText = this.buildBillMessage(removedBills, 'removal', 'this watchlist');
        const message = this.generateMessage(messageText, 'success');
        this.setState({
            checkedBills: [],
            billList: billList,
            fullLegislationList: fullLegislationList,
            totalResults: fullLegislationList.length,
            selectAllBills: false,
            holdOffLoading: true
        });
        const selectedCollectionId = selectedCollection.WatchListID
        this.handleCollectionChange(selectedCollection, () => {
            const selectedCollectionIndex = this.state.collections.findIndex(c => c.WatchListID === selectedCollectionId);
            this.setState({
                selectedCollectionIndex: selectedCollectionIndex,
                selectedCollection: this.state.collections[selectedCollectionIndex],
                messages: [message],
                skippedRecords: 0,
                numSearchedIds: 0
            }, () => {
                // Refill the bill list to its original count, if you can
                const newMaxLength = Math.min(originalLength, fullLegislationList.length);
                if (billList.length < newMaxLength) {
                    let n = billList.length;
                    while (billList.length < newMaxLength) {
                        billList.push({ ...fullLegislationList[n] });
                        n++;
                    }
                    const params = {
                        LegislationIDs: billList,
                        SessionID: this.state.selectedSession.SessionID
                    }
                    this.setState({ searchMade: false }, () => {
                        const callback = () => {
                            this.setState({ holdOffLoading: false })
                        }
                        this.getBillsResults(params, true, false, callback);
                    })
                } else {
                    this.setState({
                        holdOffLoading: false
                    });
                }
            });
        });
    }

    toggleReportMaker(autoReport) {
        this.setState(state => ({
            showReportMaker: !state.showReportMaker,
        }), () => {
            //Delete the watchlist if we arrived at this report from the interactive calendar Create Report button
            //Should only be triggered by closing a report maker that was opened automatically
            if (autoReport) {
                this.deleteCollection();
            }
        });
    }

    toggleAllBills() {
        const opposite = !this.state.selectAllBills;
        let checkedBills = [...this.state.checkedBills];
        checkedBills = new Array(this.state.billList.length).fill(opposite);
        this.setState({
            selectAllBills: opposite,
            checkedBills: checkedBills,
            lastCheckedBill: -1
        });
    }

    handleBillCheckbox(billIndex, e) {
        let checkedBills = [...this.state.checkedBills];
        let lastCheckedBill = this.state.lastCheckedBill;
        if (e.nativeEvent.shiftKey && this.state.lastCheckedBill !== -1) {
            checkedBills = checkedBills.fill(false);
            for (let i = 0; i < Math.abs(billIndex - this.state.lastCheckedBill); i++) {
                const index = this.state.lastCheckedBill + i * (billIndex - this.state.lastCheckedBill) / Math.abs(billIndex - this.state.lastCheckedBill);
                checkedBills[index] = true;
            }
        } else {
            lastCheckedBill = !checkedBills[billIndex] ? billIndex : this.state.lastCheckedBill;
        }
        checkedBills[billIndex] = !checkedBills[billIndex]
        this.setState({
            checkedBills: checkedBills,
            lastCheckedBill: lastCheckedBill
        });
    }

    quickAddBills(billsToAdd, callback) {
        let billsToSearchFor = "";
        let duplicatedBills = [];
        let ranges = [];
        let exitFn = false;
        this.setState({ quickAddErr: null, messages: [] });
        let messages = [];
        const typeRank = {
            'success': 3,
            'warning': 2,
            'error': 1
        }
        const quickErrorMessage = (text, curr) => {
            const currMessages = [...curr];
            const message = this.generateMessage(text, 'error');
            currMessages.push(message);
            currMessages.sort((a, b) => typeRank[a.type] - typeRank[b.type]);
            return currMessages;
        }
        if (this.state.selectedCollection.WatchListLegislation && this.state.selectedCollection.WatchListLegislation.filter(l => !l.DeletionDate).length > 0) {
            // After a save, we get back all legislation across all sessions. We don't want to attempt to add these for this session.
            const existingWatchListLegislation = [...new Set(this.state.selectedCollection.WatchListLegislation
                .filter(l => !l.DeletionDate && l.Sessions.find(s => s.SessionID === this.state.selectedSession?.SessionID)).map(l => l.LegislationNumber.toUpperCase()))];
            billsToSearchFor += existingWatchListLegislation.join(", ");
            let billsToAddArray = billsToAdd.split(",");
            billsToAddArray.every(b => {
                if (b.includes('-')) { //range (e.g. hb5-hb10)
                    const rangeStartAndEnd = b.split('-'); // e.g. ['hb5', 'hb10']
                    const rangeStart = rangeStartAndEnd[0]; // e.g. 'hb5'
                    const rangeStartNumber = Number.parseInt(rangeStart.replace(/^\D+/g, '')); // e.g. 5
                    const rangeEnd = rangeStartAndEnd[1];
                    const rangeEndNumber = Number.parseInt(rangeEnd.replace(/^\D+/g, '')); // e.g. 10
                    const prefix = rangeStart.replace(/\d+/, "").trim().toUpperCase();

                    if (!prefix || !validLegPrefixes.includes(prefix) || !rangeStartNumber || !rangeEndNumber || Number.isNaN(rangeStartNumber) || Number.isNaN(rangeEndNumber) || rangeStartNumber > rangeEndNumber) {
                        messages = quickErrorMessage('Invalid range: (No bills added)', messages);
                        callback(true);
                        exitFn = true; //can't quit the outer function from within every(), forEach(), etc., so store as bool to use later
                        return false; //exit the every()
                    }
                    for (let i = rangeStartNumber; i <= rangeEndNumber; i++) {
                        const billNumber = prefix + i.toString().trim().toUpperCase();
                        if (!existingWatchListLegislation.includes(billNumber)) {
                            billsToSearchFor += ", " + billNumber;
                        } else {
                            duplicatedBills.push(billNumber);
                        }
                    }
                    ranges.push({ prefix: prefix, rangeStart: rangeStartNumber, rangeEnd: rangeEndNumber })
                } else { //individual
                    const billKey = Number.parseInt(b.replace(/^\D+/g, '')); // e.g. 5
                    if (!billKey) {
                        messages = quickErrorMessage('Invalid bill number: ' + b.trim() + ' (No bills added)', messages);
                        callback(true);
                        exitFn = true; //can't quit the outer function from within every(), forEach(), etc., so store as bool to use later
                        return false; //exit the every()
                    }

                    const prefix = b.replace(/\d+/, "").trim().toUpperCase();
                    if (!validLegPrefixes.includes(prefix)) {
                        messages = quickErrorMessage('Invalid bill prefix: ' + prefix + ' (No bills added)', messages);
                        callback(true);
                        exitFn = true;
                        return false;
                    }

                    if (!existingWatchListLegislation.includes(b.trim().toUpperCase())) {
                        billsToSearchFor += ", " + b.trim();
                    } else {
                        duplicatedBills.push(b.trim().toUpperCase())
                    }
                }
                return true;
            })
        } else { //no legislation currently in the existing watchlist
            if (billsToAdd.includes('-')) { //includes at least one range (e.g. hb5-hb10)
                let billsToAddArray = billsToAdd.split(",");
                billsToAddArray.every(b => {
                    if (b.includes('-')) { //range (e.g. hb5-hb10)
                        const rangeStartAndEnd = b.split('-'); // e.g. ['hb5', 'hb10']
                        const rangeStart = rangeStartAndEnd[0]; // e.g. 'hb5'
                        const rangeStartNumber = Number.parseInt(rangeStart.replace(/^\D+/g, '')); // e.g. 5
                        const rangeEnd = rangeStartAndEnd[1];
                        const rangeEndNumber = Number.parseInt(rangeEnd.replace(/^\D+/g, '')); // e.g. 10
                        const prefix = rangeStart.replace(/\d+/, "").trim().toUpperCase();
                        if (!prefix || !validLegPrefixes.includes(prefix) || !rangeStartNumber || !rangeEndNumber || Number.isNaN(rangeStartNumber) || Number.isNaN(rangeEndNumber) || rangeStartNumber > rangeEndNumber) {
                            messages = quickErrorMessage('Invalid range: (No bills added)', messages);
                            callback(true);
                            exitFn = true; //can't quit the outer function from within every(), forEach(), etc., so store as bool to use later
                            return false; //exit the every()
                        }
                        for (let i = rangeStartNumber; i <= rangeEndNumber; i++) {
                            const billNumber = prefix + i.toString().trim().toUpperCase();
                            if (billsToSearchFor.length) { billsToSearchFor += ", " }
                            billsToSearchFor += billNumber;
                        }
                        ranges.push({ prefix: prefix, rangeStart: rangeStartNumber, rangeEnd: rangeEndNumber })
                    } else {
                        billsToSearchFor += (billsToSearchFor.length ? ", " : "") + b.trim();
                    }
                    return true;
                })
            } else {
                let billsToAddArray = billsToAdd.split(",");
                billsToAddArray.every(b => {

                    const billKey = Number.parseInt(b.replace(/^\D+/g, '')); // e.g. 5
                    if (!billKey) {
                        messages = quickErrorMessage('Invalid bill number: ' + b.trim() + ' (No bills added)', messages);
                        callback(true);
                        exitFn = true; //can't quit the outer function from within every(), forEach(), etc., so store as bool to use later
                        return false; //exit the every()
                    }

                    const prefix = b.replace(/\d+/, "").trim().toUpperCase();
                    if (!validLegPrefixes.includes(prefix)) {
                        messages = quickErrorMessage('Invalid bill prefix: ' + prefix + ' (No bills added)', messages);
                        callback(true);
                        exitFn = true;
                        return false;
                    }

                    if (billsToSearchFor.length) { billsToSearchFor += ", " }
                    billsToSearchFor += b;
                    return true;
                })
            }
        }
        if (exitFn) {
            this.setState({ messages });
            return;
        }
        const params = {
            LegislationNumbers: [{
                LegislationNumber: billsToSearchFor
            }],
            SessionID: this.state.selectedSession.SessionID
        };
        this.props.actions.getBillList(params).then(() => {
            let billList = this.props.bills.billList;
            //Filter to only one result per bill per session since DB sometimes returns duplicates
            billList = billList.filter((item, pos) => billList.findIndex(i => i.LegislationNumber === item.LegislationNumber && i.SessionID === item.SessionID) === pos);
            let watchlist = JSON.parse(JSON.stringify(this.state.selectedCollection));
            //Check to see if some of the bills the user wanted to add don't exist
            let missedBills = [];
            // Match text that has two letters followed by numbers. There can be white space between them.
            const foundBills = billsToSearchFor.match(/[a-zA-Z]{2}\s*(?=[0-9])[0-9]*/ig) || [];

            foundBills.forEach(fb => {
                const noWhiteSpaceBill = fb.replace(/\s/g, "").toUpperCase();
                if (!billList.find(bill => bill.LegislationNumber.toUpperCase() === noWhiteSpaceBill)) { //desired bill is not in the bill search response
                    //if the non-found bill was only requested within a range (e.g. hb120 within hb1-hb1000), then don't include it as a missed bill, because obviously not every number in a range will be expected
                    const billKey = noWhiteSpaceBill.replace(/^\D+/g, '');
                    const billPrefix = noWhiteSpaceBill.replace(/\d+/, "");
                    if (!ranges.find(range => range.prefix === billPrefix && range.rangeStart <= billKey && range.rangeEnd >= billKey)) {
                        missedBills.push(noWhiteSpaceBill);
                    }
                }
            })

            if (duplicatedBills.length) {
                const text = this.buildBillMessage(duplicatedBills, 'warning', 'this watchlist');
                messages.push(this.generateMessage(text, 'warning'));
            }
            let saveWatchlist = false;
            const newBills = [];
            billList.forEach(bill => {
                // Make sure the bill isn't already a part of the watchlist
                if (!watchlist.WatchListLegislation.find(leg => !leg.DeletionDate && leg.LegislationID === bill.LegislationID)) {
                    saveWatchlist = true;
                    newBills.push(bill.LegislationNumber);
                    watchlist.WatchListLegislation.push({
                        LegislationID: bill.LegislationID,
                        LegislationNumber: bill.LegislationNumber,
                        Sessions: [{ SessionID: bill.SessionID }],
                        WatchListID: watchlist.WatchListID
                    });
                }
            });
            if (missedBills.length > 0) {
                // Doesn't quite fit the format of the others ...
                messages = quickErrorMessage(`${missedBills.length === 1 ? "This bill" : missedBills.length > 7 ? missedBills.length.toString() + " bills" : "These bills"} could not be added${missedBills.length <= 7 ? ': ' + missedBills.join(", ") : ""}`, messages);
            }
            if (saveWatchlist) {
                this.handleCollectionChange(watchlist, (err => {
                    const selectedCollectionIndex = this.state.collections.findIndex(c => c.WatchListID === watchlist.WatchListID);
                    if (!err) {
                        if (newBills.length > 0) {
                            const text = this.buildBillMessage(newBills, 'success', 'this watchlist');
                            const message = this.generateMessage(text, 'success');
                            messages.push(message);
                        }
                        const addedBills = [...this.state.addedBills].concat(newBills);
                        this.setState({
                            billList: billList,
                            fullLegislationList: billList,
                            totalResults: billList.length,
                            checkedBills: [],
                            lastCheckedBill: -1,
                            selectedCollectionIndex: selectedCollectionIndex,
                            selectedCollection: this.state.collections[selectedCollectionIndex],
                            messages: messages.toSorted((a, b) => typeRank[a.type] - typeRank[b.type]),
                            addedBills
                        })
                    }
                }));
            } else if (ranges.length) {
                messages = quickErrorMessage('No bills found', messages);
                this.setState({ messages });
            } else {
                // Would this just be all error/warnings?
                this.setState({ messages: messages.toSorted((a, b) => typeRank[b.type] - typeRank[a.type]) });
            }
            callback(false);
        }).catch(err => {
            if (err === 'Aborted') {
                return err;
            }
            this.setState({
                isFetching: false
            });
            this.props.actions.makeToast([{ message: err, type: "failure" }]);
            callback(true);
        })
    }

    toggleAllNotes() {
        const opposite = !this.state.showAllNotes;
        this.setState({
            showAllNotes: opposite
        });
        for (let i = 0; i < this._billResultRefs.length; i++) {
            if (this._billResultRefs[i] && this._billResultRefs[i].current) {
                this._billResultRefs[i].current.toggleBillNotesFromParent(opposite)
            }
        }
    }

    unload() {
        //Delete the watchlist when the page is unloaded if the user leaves when the report maker is still open
        this.deleteCollection();
    }

    toggleSidebar() {
        this.setState({
            showSidebar: !this.state.showSidebar
        })
    }

    toggleHelpModal() {
        this.setState({
            showHelpModal: !this.state.showHelpModal
        })
    }

    getReportTitleObject() {
        return { Name: this.getReportTitle() };
    }

    getReportTitle() {
        if (this.state.selectedCollection) { return ''; }

        let title = '';
        if (this.state.allLegislation) {
            title = "All legislation";
        } else if (this.state.mostFrequent) {
            title = "Most frequently accessed bills";
        } else if (this.state.isPending) {
            title = "Pending bills";
        } else if (this.state.selectedBillStatusCategory && this.state.billStatusCategoryList.find(opt => opt.value === this.state.selectedBillStatusCategory)) {
            title = this.state.billStatusCategoryList.find(opt => opt.value === this.state.selectedBillStatusCategory).label;
            if (this.state.currentStatus) {
                title += " (Current Status)";
            }
        }
        return title;
    }

    handleToggleCompositeView() {
        let billList = [];
        this.state.fullLegislationList.forEach(x => {
            billList.push({
                LegislationNumber: x.LegislationNumber,
                SessionID: x.SessionID
            })
        });
        const jsonData = JSON.stringify({
            showCatchline: true,
            showCurrentStatus: false,
            showTitle: false,
            showChiefPatron: true,
            showAllPatrons: false,
            showSummary: false,
            showNotes: true,
            userCreated: this.props.login.userProfile.email || '',
            selectedNotes: "current",
            selectedCollection: this.state.selectedCollection && this.state.selectedCollection.Name && this.state.selectedCollection.WatchListID ? this.state.selectedCollection.WatchListID : '',
            reportTitle: this.state.selectedCollection?.Name || '',
            showHistory: {
                all: false,
                recent: true,
                mostRecentAmount: "1",
                showVotes: false,
                Committee: true,
                Subcommittee: false
            },
            showHouseAmendments: false,
            showSenateAmendments: false,
            showConferenceAmendments: false,
            showGovernorsRecommendations: false,
            showStatus: {},
            showCommitteeEvent: {},
            showLdNumber: false,
            showClerkNames: false,
            showDlsStaffNames: false,
            personalMessage: "",
            billList: billList
        });
        this.props.actions.saveBillReportInformation(window.btoa(jsonData)).then(() => {
            const billReportInformation = this.props.report.billReportInformation;
            if (billReportInformation && billReportInformation.ReportNumber) {
                this.props.history.push('/bill-search-report/composite/' + billReportInformation.ReportNumber)
            } else {
                this.props.actions.makeToast([{ message: "Composite View Generation Failed", type: "failure" }]);
            }
        }).catch(err => {
            if (err === 'Aborted') {
                return;
            }
            console.log(err)
            this.props.actions.makeToast([{ message: "Composite View Generation Failed", type: "failure" }]);
        });
    }

    handleToggleSearchExecuted(newSearchExecuted) {
        this.setState({ searchExecuted: newSearchExecuted });
    }

    updateSortWatchlists(value) {
        const currentlySelectedId = this.state.selectedCollection?.WatchListID;
        this.setState({
            sortWatchlistsBy: value
        }, () => {
            if (currentlySelectedId) {
                const selectedCollectionIndex = this.state.collections.findIndex(c => c.WatchListID === currentlySelectedId);
                this.setState({
                    selectedCollectionIndex: selectedCollectionIndex,
                    selectedCollection: this.state.collections[selectedCollectionIndex]
                });
            }
        });
    }

    /**
     * @typedef {Object} LineCountResult
     * @property {number} lineCount
     * @property {string} [firstLine]
     */
    /**
     * @typedef {Object} Message
     * @property {string} text
     * @property {'success' | 'warning' | 'error'} type
     * @property {LineCountResult} [show]
     */
    /**
     * @param {string} text
     * Text to use for calculations
     * @param {'success' | 'warning' | 'error'} type
     * message type
     * @returns {Message}
     * A built message
     */
    generateMessage(text, type) {
        const sourceElement = document.getElementsByClassName('message-box')[0];
        const width = sourceElement.parentElement.getBoundingClientRect().width;
        const newDiv = document.createElement('div');
        document.body.appendChild(newDiv);
        const copyTheseStyles = window.getComputedStyle(sourceElement);
        for (const style of copyTheseStyles) {
            newDiv.style[style] = copyTheseStyles[style];
        }
        newDiv.style.position = 'absolute';
        newDiv.style.visibility = 'hidden';
        newDiv.style.display = 'block';
        newDiv.style.height = 'fit-content';
        newDiv.style.top = '0';
        newDiv.style.left = '0';
        newDiv.style.width = width + 'px';
        newDiv.textContent = text;
        const range = document.createRange();
        range.setStart(newDiv.firstChild, 0);
        let end = newDiv.firstChild.length - 1;
        range.setEnd(newDiv.firstChild, end);
        const lineCount = range.getClientRects().length;
        if (lineCount === 1) {
            document.body.removeChild(newDiv);
            return {
                text,
                type,
                show: undefined
            }
        } else {
            let lc = lineCount;
            while (lc > 1) {
                end--;
                range.setEnd(newDiv.firstChild, end);
                lc = range.getClientRects().length;
            }
            range.setEnd(newDiv.firstChild, end - 3);
            const firstLine = range.toString() + '...';
            document.body.removeChild(newDiv);
            return {
                text,
                type,
                show: firstLine
            }
        }

    }

    closeMessage(index) {
        const messages = [...this.state.messages];
        messages.splice(index, 1);
        this.setState({ messages });
    }

    buildBillMessage(bills, type, watchlistName) {
        const billInfo = bills.length === 1 ? bills[0] :
            bills.length === 2 ?
                bills[0] + " and " + bills[1] :
                bills.join(', ').replace(/, ([^,]*)$/, ', and $1');
        const wasWere = bills.length === 1 ? 'was' : 'were';
        const addedText = type === 'success' ? 'added to' :
            type === 'warning' ? 'already in'
                : 'removed from';
        const fullText = `${billInfo} ${wasWere} ${addedText} ${watchlistName}.`;
        return fullText;
    }

    // This isn't completely reliable on mobile, so try a couple times
    scrollToElementWithRetry(retries) {
        const id = localStorage.getItem("BILL_INFO") + "-link";
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
        } else if (retries > 0) {
            setTimeout(() => this.scrollToElementWithRetry(retries - 1), 100);
        }
    }

    render() {
        const { isFetching, sessionID, billList, showSidebar, collectionIsLoading, totalResults } = this.state;
        const { errorMessage } = this.props.bills;

        const userCanUseCollections = Boolean(this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR));
        const isPaid = !!this.props.login.userClaims?.roles?.find(s => s === 'PaidLegislationCollectionsAuthor')

        const nextPageLoadingHeight = '100px';

        let billResultRefs = [];
        billList.forEach((_b) => billResultRefs.push(React.createRef()));
        this._billResultRefs = billResultRefs;

        let toggleArrows = [];
        const isAuthor = this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR);
        let sidebar;
        if (document.getElementsByClassName('sidebar-toggle-open').length > 0) {
            sidebar = document.getElementsByClassName('sidebar-toggle-open')[0];
        } else if (document.getElementsByClassName('sidebar-toggle-closed').length > 0) {
            sidebar = document.getElementsByClassName('sidebar-toggle-closed')[0];
        }
        const sidebarRect = sidebar ? sidebar.getBoundingClientRect() : null;
        const height = sidebarRect?.height ?? 0;
        const arrowDistance = 440;
        let arrowPosition = 55;
        toggleArrows.push(<button key={'0-sidebar-arrow'} type="button" aria-expanded={showSidebar} onClick={this.toggleSidebar} className={showSidebar ? "sidebar-button arrow-up white-chevron" : "sidebar-button arrow-down white-chevron"} style={{ top: (arrowPosition + 'px'), position: 'absolute' }} aria-label={`${showSidebar ? 'close' : 'open'} sidebar`} />);
        const count = Math.floor((height - 55) / arrowDistance);
        for (let i = 1; i < count; i++) {
            arrowPosition += arrowDistance;
            toggleArrows.push(<button key={`${i}-sidebar-arrow`} type="button" aria-expanded={showSidebar} onClick={this.toggleSidebar} className={showSidebar ? "sidebar-button arrow-up white-chevron" : "sidebar-button arrow-down white-chevron"} style={{ top: (arrowPosition + 'px'), position: 'absolute' }} aria-label={`${showSidebar ? 'close' : 'open'} sidebar`} />);
        }

        const sortOptions = [
            { label: 'Bill Number - Ascending', value: 'Bill|ASC' },
            { label: 'Bill Number - Descending', value: 'Bill|DESC' },
        ]
        if (this.state.displayChapterNumber) {
            sortOptions.push({ label: 'Chapter Number - Ascending', value: 'CHAP|ASC' });
            sortOptions.push({ label: 'Chapter Number - Descending', value: 'CHAP|DESC' });
        }
        sortOptions.push({ label: 'Status - Ascending', value: 'Status|ASC' });
        sortOptions.push({ label: 'Status - Descending', value: 'Status|DESC' });
        // in case selected is chaptered sort, and then we dont do chaptered results
        const determinedSelectedSort = sortOptions.find(opt => opt.value === this.state.selectedSort) ?? sortOptions[0];
        return (
            <div className="bill-theme bill-search-container">
                {this.state.historicalSessionRedirect &&
                    <HistoricalRedirectPopup closePopup={() => this.state.historicalSessionRedirect(false)} redirect={() => this.state.historicalSessionRedirect(true)} />
                }
                {this.state.showHelpModal &&
                    <SearchHelp closeModal={this.toggleHelpModal} />
                }
                {this.state.showReportMaker &&
                    <ReportMaker
                        toggleReportMaker={this.toggleReportMaker}
                        billList={this.state.checkedBills.find(c => c) ? this.state.billList.filter((b, i) => this.state.checkedBills[i]) : this.state.mostFrequent ? this.state.billList : this.state.fullLegislationList}
                        collections={this.state.collections}
                        selectedCollection={this.state.selectedCollection || this.getReportTitleObject()}
                        autoReport={this.state.autoReport}
                        reportTitle={this.getReportTitle()}
                        history={this.props.history}
                    />
                }
                <div className={showSidebar ? "inner-grid one-toggle-and-three" : "inner-grid toggle-and-three"}>
                    <div>
                        <LegislationWatchlists
                            collections={this.state.collections}
                            isLoading={this.state.collectionIsLoading}
                            error={this.props.collection.collectionError}
                            selectedCollectionIndex={this.state.selectedCollectionIndex}
                            selectCollection={this.selectCollection}
                            createCollection={this.createCollection}
                            collectionIsSaving={this.state.collectionIsSaving}
                            location={this.props.history.location.pathname}
                            isAuthor={isAuthor}
                            sortWatchlistsBy={this.state.sortWatchlistsBy}
                            updateSortWatchlists={this.updateSortWatchlists}
                            isFetching={isFetching}
                        />
                        <AdvancedSearchBox
                            ref={this.searchBox}
                            selectedBillNumbers={this.state.selectedBillNumbers}
                            selectedBillRangeBeginning={this.state.selectedBillRangeBeginning}
                            selectedBillRangeEnd={this.state.selectedBillRangeEnd}
                            selectedChapterNumber={this.state.selectedChapterNumber}
                            selectedKeywords={this.state.selectedKeywords}
                            selectedBillEvent={this.state.selectedBillEvent}
                            billEventOptions={this.state.billEventOptions}
                            sessionOptions={this.state.sessionOptions}
                            selectedSession={this.state.selectedSession}
                            billStatusCategoryList={this.state.billStatusCategoryList}
                            selectedBillStatusCategory={this.state.selectedBillStatusCategory}
                            billStatusStartDate={this.state.billStatusStartDate}
                            billStatusEndDate={this.state.billStatusEndDate}
                            selectedCommittee={this.state.selectedCommittee}
                            committeeList={this.state.filteredCommitteeList}
                            subcommitteeList={this.state.subcommitteeList}
                            selectedSubcommittee={this.state.selectedSubcommittee}
                            patronList={this.state.filteredPatronList}
                            patronRoles={this.state.patronRoles}
                            selectedPatron={this.state.selectedPatron}
                            selectedPatronType={this.state.selectedPatronType}
                            selectedChamber={this.state.selectedChamber}
                            selectedBillType={this.state.selectedBillType}
                            billEventEndDate={this.state.billEventEndDate}
                            billEventStartDate={this.state.billEventStartDate}
                            resetUrl={this.resetUrl}
                            handleSubmit={this.handleSubmit}
                            handleTextChange={this.handleTextChange}
                            handleSelectChange={this.handleSelectChange}
                            handleDateChange={this.handleDateChange}
                            committeeChange={this.committeeChange}
                            chamberChange={this.chamberChange}
                            sessionChange={this.sessionChange}
                            clearForm={this.clearForm}
                            isFetching={this.state.isFetching}
                            handlePatronChange={this.handlePatronChange}
                            handlePatronTypeChange={this.handlePatronTypeChange}
                            subjectList={this.state.subjectList}
                            selectedSubject={this.state.selectedSubject}
                            toggleGroup={this.toggleGroup}
                            billFieldset={this.state.billFieldset}
                            keywordFieldset={this.state.keywordFieldset}
                            statusFieldset={this.state.statusFieldset}
                            activityFieldset={this.state.activityFieldset}
                            membersFieldset={this.state.membersFieldset}
                            committeesFieldset={this.state.committeesFieldset}
                            subjectFieldset={this.state.subjectFieldset}
                            showCategories={this.state.showCategories}
                            toggleShowCategories={this.toggleShowCategories}
                            location={this.props.history.location.pathname}
                            searchParam={this.props.history.location.search}
                            billVersionList={this.state.billVersionList}
                            selectedBillVersion={this.state.selectedBillVersion}
                            billSummaryList={this.state.billSummaryList}
                            selectedSummaryVersion={this.state.selectedSummaryVersion}
                            selectedLocation={this.state.selectedLocation}
                            keywordUseGlobalSessionSearch={this.state.keywordUseGlobalSessionSearch}
                            handleRadioChange={this.handleRadioChange}
                            handleCurrentStatusChange={this.handleCurrentStatusChange}
                            currentStatus={this.state.currentStatus}
                            handleIncludeFailedChange={this.handleIncludeFailedChange}
                            includeFailed={this.state.includeFailed}
                            toggleHelpModal={this.toggleHelpModal}
                            failedToGetSessions={this.state.failedToGetSessions}
                            showReportMaker={this.state.showReportMaker}
                            userClaims={this.props.login.userClaims}
                        />
                    </div>
                    <div className={showSidebar ? "sidebar-toggle-open" : "sidebar-toggle-closed"} onClick={this.toggleSidebar}>
                        {toggleArrows.map((a, i) => {
                            return (a)
                        })}
                    </div>
                    {this.state.failedToGetSessions ? <div className="center input-feedback" style={{ fontSize: '1em' }}>Failed to retrieve sessions. Please refresh & try again.</div> : !this.state.selectedSession ? <div className="center-spinner spinner">Loading...</div>
                        :
                        this.state.showCategories && !collectionIsLoading ?
                            <BillCategories
                                session={this.state.sessionOptions.find(session => session.SessionCode === this.props.nav.session)}
                                patronList={this.state.patronList}
                                committeeList={this.state.groupedCommitteeList}
                                subjectList={this.state.subjectList}
                                introDateList={this.state.introDateList}
                                statusCategoriesList={this.state.billStatusCategoryList}
                                isLoading={this.state.billStatusCategoryListIsLoading}
                                history={this.props.history}
                                location={this.props.history.location.pathname}
                                selectedSession={this.state.selectedSession}
                                includeFailed={this.state.includeFailed}
                            />
                            :
                            <div id="results-div">
                                {userCanUseCollections &&
                                    <CollectionControls
                                        searchMade={this.state.searchMade}
                                        collections={this.state.collections}
                                        selectedCollection={this.state.selectedCollection}
                                        selectedCollectionIndex={this.state.selectedCollectionIndex}
                                        handleCollectionChange={this.handleCollectionChange}
                                        handleToggleCompositeView={this.handleToggleCompositeView}
                                        selectCollection={this.selectCollection}
                                        collectionIsSaving={this.state.collectionIsSaving}
                                        deleteCollection={this.deleteCollection}
                                        checkedBills={this.state.checkedBills}
                                        addToWatchlists={this.addToWatchlists}
                                        billList={this.state.billList}
                                        memberList={this.state.patronList}
                                        committeeList={this.state.groupedCommitteeList}
                                        criteriaTypes={this.state.criteriaTypes}
                                        quickAddBills={this.quickAddBills}
                                        quickAddErr={this.state.quickAddErr}
                                        toggleReportMaker={this.toggleReportMaker}
                                        showAllNotes={this.state.showAllNotes}
                                        toggleAllNotes={this.toggleAllNotes}
                                        removeWatchlistBills={this.removeWatchlistBills}
                                        isFetching={this.state.isFetching}
                                        isPaid={isPaid}
                                        messages={this.state.messages}
                                        closeMessage={this.closeMessage}
                                    />
                                }
                                {this.state.searchMade &&
                                    <>
                                        <span id="your-search-anchor" className="txt-greyed small-text">Your Search</span>
                                        <SearchSelections
                                            currentStatus={this.state.currentStatus}
                                            selectedSession={this.state.selectedSession}
                                            selectedBillNumbers={this.state.selectedBillNumbers}
                                            selectedBillRangeBeginning={this.state.selectedBillRangeBeginning}
                                            selectedBillRangeEnd={this.state.selectedBillRangeEnd}
                                            selectedChapterNumber={this.state.selectedChapterNumber}
                                            selectedKeywords={this.state.searchedKeywords || this.state.selectedKeywords}
                                            selectedBillEvent={this.state.billEventOptions.find(opt => opt.value === this.state.selectedBillEvent)}
                                            selectedBillStatusCategory={this.state.billStatusCategoryList.find(opt => opt.value === this.state.selectedBillStatusCategory)}
                                            billStatusStartDate={this.state.billStatusStartDate}
                                            billStatusEndDate={this.state.billStatusEndDate}
                                            selectedCommittee={this.state.committeeList.find(opt => opt.value === this.state.selectedCommittee)}
                                            selectedSubcommittee={this.state.subcommitteeList.find(opt => opt.value === this.state.selectedSubcommittee)}
                                            selectedPatron={this.state.patronList.find(opt => opt.value === this.state.selectedPatron)}
                                            selectedPatronType={this.state.patronRoles.filter(role => this.state.selectedPatronType.includes(role.PatronTypeID))}
                                            selectedChamber={this.state.selectedChamber}
                                            billEventEndDate={this.state.billEventEndDate}
                                            billEventStartDate={this.state.billEventStartDate}
                                            selectedSubject={this.state.subjectList.find(opt => opt.value === this.state.selectedSubject)}
                                            includeFailed={this.state.includeFailed}
                                            handleSelectionClear={this.handleSelectionClear}
                                            handleMultiSelectionClear={this.handleMultiSelectionClear}
                                            isFetching={this.state.isFetching}
                                            searchExecuted={this.state.searchExecuted}
                                            handleToggleSearchExecuted={this.handleToggleSearchExecuted}
                                            allLegislation={this.state.allLegislation}
                                            mostFrequent={this.state.mostFrequent}
                                            introductionDate={this.state.introductionDate}
                                            subcommitteeList={this.state.subcommitteeList}
                                        />
                                    </>}
                                {!isFetching &&
                                    <>
                                        <div id="search-results-wrapper" className="flex-row search-results-title-section">
                                            {this.state.searchMade ?
                                                <>
                                                    {this.state.allLegislation && <h2>All legislation</h2>}
                                                    {this.state.mostFrequent && <h2>Most frequently accessed bills</h2>}
                                                    {this.state.isPending && <h2>Pending bills</h2>}
                                                    {!this.state.isPending && !this.state.mostFrequent && !this.state.allLegislation && <h2>{billList.length === 0 && "No "}Search Results</h2>}                                                </>
                                                : <div></div>}
                                            {(!this.state.selectedCollection || this.state.searchMade) &&
                                                <div className="inline-list">
                                                    {billList.length > 0 &&
                                                        <React.Fragment>
                                                            {!errorMessage && parseInt(this.state.totalResults, 10) !== 'NaN' && <div id="search-result-count" className="txt-greyed">{this.state.totalResults} {this.state.searchMade ? "Result" : "Item"}{this.state.totalResults !== 1 && "s"}</div>}
                                                            <button onClick={() => this.toggleReportMaker()} id="create-report-button" type="button" className={`${this.state.selectedCollection ? 'set-right ' : ''}button small-button`} style={{ marginRight: '0px', marginTop: "8px" }}>Create Report</button>
                                                        </React.Fragment>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </>
                                }
                                {this.state.selectedCollection &&
                                    <div className="flex-row flex-vertical-center notes-and-controls" />
                                }
                                <div className="public-list search-results">
                                    {isFetching && !this.state.skippedRecords ?
                                        <div className="spinner"></div>
                                        :
                                        <>
                                            {errorMessage ?
                                                <p className="message-error">{errorMessage}</p>
                                                :
                                                null
                                            }
                                        </>
                                    }
                                    {(!isFetching || this.state.skippedRecords) && !errorMessage ?
                                        billList.length > 0 ?
                                            <ul className="slidedown-list">
                                                <div className='flex-row'>
                                                    {userCanUseCollections ?
                                                        <label htmlFor="sr-select-all"
                                                            className="txt-greyed">
                                                            <input id="sr-select-all" checked={this.state.selectAllBills} onChange={this.toggleAllBills} type="checkbox" style={{ verticalAlign: 'bottom', marginRight: '10px' }} />
                                                            Select all</label>
                                                        :
                                                        <div />}
                                                    {this.state.mostFrequent ? <div style={{ height: "26.2px" }} /> :
                                                        this.state.selectedCollectionIndex > -1 ?
                                                            <div>
                                                                <div id="search-result-count" style={{ height: "26.2px", color: "#757575" }} className="txt-greyed">{this.state.totalResults} Item{this.state.totalResults !== 1 && "s"}</div>
                                                            </div> :
                                                            <Select
                                                                id="se-bill-sort"
                                                                options={sortOptions}
                                                                placeholder="All"
                                                                onChange={(opt) => { this.setState({ selectedSort: opt.value }, () => { this.searchBox.current.handleSubmit(); }) }}
                                                                value={determinedSelectedSort}
                                                                classNamePrefix='search-sorting-options'
                                                            />
                                                    }
                                                </div>
                                                {!this.state.displayCrossSession && <hr className="faded-line" />}
                                                {billList.map((bill, i) =>
                                                    <React.Fragment key={`${bill.LegislationID}-${this.state.selectedCollection?.WatchListID ?? ''}`}>
                                                        {this.state.displayCrossSession && i === 0 &&
                                                            <div className="search-session-header">
                                                                <label>{this.state.sessionOptions.find(x => x.SessionID === bill.SessionID).SessionYear + " " + this.state.sessionOptions.find(x => x.SessionID === bill.SessionID).DisplayName}</label>
                                                            </div>
                                                        }
                                                        {this.state.displayCrossSession && billList[i + 1] && billList[i].SessionID != billList[i + 1].SessionID || this.state.displayCrossSession && billList[i + 1] === undefined
                                                            ?
                                                            <React.Fragment>
                                                                <BillInfoComponent
                                                                    key={i}
                                                                    ref={this._billResultRefs[i]}
                                                                    userCanUseCollections={userCanUseCollections}
                                                                    bill={bill}
                                                                    billIndex={i}
                                                                    sessionID={sessionID}
                                                                    toggleShowData={this.toggleShowData}
                                                                    expanded={this.state[bill.LegislationID]}
                                                                    sessionCode={this.state.sessionOptions.find(session => session.SessionID === bill.SessionID) && this.state.sessionOptions.find(session => session.SessionID === bill.SessionID).SessionCode}
                                                                    selectedCollection={this.state.selectedCollection}
                                                                    handleCollectionChange={this.handleCollectionChange}
                                                                    collectionIsSaving={this.state.collectionIsSaving}
                                                                    handleBillCheckbox={e => this.handleBillCheckbox(i, e)}
                                                                    checked={this.state.checkedBills[i]}
                                                                    selectedKeywords={this.state.searchedKeywords || this.state.selectedKeywords}
                                                                    selectedLocation={this.state.displaySelectedLocation}
                                                                    searchMade={this.state.searchMade}
                                                                    session={this.state.sessionOptions.find(x => x.SessionID === bill.SessionID)}
                                                                    displayCrossSession={this.state.displayCrossSession}
                                                                    newSession={true}
                                                                    displayChapterNumber={this.state.displayChapterNumber}
                                                                    addedToWatchlist={!!this.state.addedBills.find(id => id === bill.LegislationNumber)}
                                                                />
                                                                {billList[i + 1] &&
                                                                    <div className="search-session-header">
                                                                        <label>{this.state.sessionOptions.find(x => x.SessionID === billList[i + 1].SessionID).SessionYear + " " + this.state.sessionOptions.find(x => x.SessionID === billList[i + 1].SessionID).DisplayName}</label>
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                            :
                                                            <BillInfoComponent
                                                                key={i}
                                                                ref={this._billResultRefs[i]}
                                                                userCanUseCollections={userCanUseCollections}
                                                                bill={bill}
                                                                billIndex={i}
                                                                sessionID={sessionID}
                                                                sessionCode={this.state.sessionOptions.find(session => session.SessionID === bill.SessionID) && this.state.sessionOptions.find(session => session.SessionID === bill.SessionID).SessionCode}
                                                                selectedCollection={this.state.selectedCollection}
                                                                handleCollectionChange={this.handleCollectionChange}
                                                                collectionIsSaving={this.state.collectionIsSaving}
                                                                handleBillCheckbox={e => this.handleBillCheckbox(i, e)}
                                                                checked={this.state.checkedBills[i]}
                                                                selectedKeywords={this.state.searchedKeywords || this.state.selectedKeywords}
                                                                toggleShowData={this.toggleShowData}
                                                                expanded={this.state[bill.LegislationID]}
                                                                selectedLocation={this.state.displaySelectedLocation}
                                                                searchMade={this.state.searchMade}
                                                                session={this.state.sessionOptions.find(x => x.SessionID === bill.SessionID)}
                                                                displayCrossSession={this.state.displayCrossSession}
                                                                displayChapterNumber={this.state.displayChapterNumber}
                                                                addedToWatchlist={!!this.state.addedBills.find(id => id === bill.LegislationNumber)}
                                                            />
                                                        }
                                                    </React.Fragment>
                                                )}
                                            </ul>
                                            : collectionIsLoading ? <div className="center-spinner spinner">Loading...</div> :
                                                (![NaN, undefined].includes(parseInt(totalResults, 10)) ? <div className='txt-greyed' style={{ fontSize: '13px', float: 'right' }}>{`${totalResults} item${totalResults !== 1 ? 's' : ''}`}</div>
                                                    : <div />)
                                        : null
                                    }
                                </div>
                            </div>
                    }
                </div>
                <div
                    ref={loadingRef => (this.loadingRef = loadingRef)}
                    style={{ position: 'relative', bottom: !isFetching && this.state.hasNextPage ? ((window.innerHeight || document.documentElement.clientHeight) * .35) + 'px' : null }}
                >
                    {isFetching && this.state.skippedRecords ?
                        <div className="spinner" style={{ height: nextPageLoadingHeight, margin: 'auto' }}></div>
                        :
                        this.state.hasNextPage ?
                            <div style={{ marginTop: nextPageLoadingHeight }} />
                            : null
                    }
                </div>
            </div>
        )
    }
}

const PublicBillSearch = connect(
    (state) => {
        const { bills, session, members, committee, patrons, nav, collection, login, report } = state;
        return {
            bills,
            session,
            members,
            committee,
            patrons,
            nav,
            collection,
            login,
            report
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, authActionCreators, committeeActionCreators, billActionCreators, sessionActionCreators, memberActionCreators, patronActionCreators, navActionCreators, collectionActionCreators, reportActionCreators), dispatch)
        }
    }
)(BillSearchComponent)

export default PublicBillSearch;
